<template>
  <div id="homepageTabbedFilter" :class="{'homepage-tabbed-filter': true, 'homepage-tabbed-filter--mobile': isMobile960, 'homepage-tabbed-filter--mobile open': isMobile960 && isFilterOpen}" :data-brand="getBrand">
    <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/ion-rangeslider/2.3.1/css/ion.rangeSlider.min.css"/>

    <!-- Mobile Trigger -->
    <div class="flex-row-center tabbed-filter-trigger">
      <button type="button" class="btn tabbed-filter-btn" data-target="#homepageTabbedFilter" data-trigger="open" @click="toggleFilterOpenClose">Shop Vehicles <span class="filter-icon"></span></button>
    </div>

    <!-- Modal -->
    <div class="modal fade" id="tabbedFilterModal" tabindex="-1" role="dialog" aria-labelledby="tabbedFilterModalLabel" data-backdrop="static"></div>

    <!-- Content -->
    <div class="full-width-search-bar search-bar-component">
      <div class="container">
        <div class="row">
          <div class="col-xs-12">
            <p class="tabbed-search-title">Explore Hometown Dealer</p>
            <h2 class="tabbed-search-heading">Shopping Tools</h2>
          </div>
        </div>
      </div>
      <div class="container-fluid">
        <div class="row">
          <div class="col-xs-12">
            <div class="interaction-bar-search-bar">
              <div class="search-bar">
                <form action="/vehicles" role="search">
                  <div class="input-group">
                    <span class="alternate-magnifying-glass-icon">
                      <svg fill="none" height="20" viewBox="0 0 20 20" width="20" xmlns="http://www.w3.org/2000/svg">
                        <path d="M9.16667 15.8333C12.8486 15.8333 15.8333 12.8486 15.8333 9.16667C15.8333 5.48477 12.8486 2.5 9.16667 2.5C5.48477 2.5 2.5 5.48477 2.5 9.16667C2.5 12.8486 5.48477 15.8333 9.16667 15.8333Z" stroke="#000000" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"></path>
                        <path d="M17.5 17.5L13.875 13.875" stroke="#000000" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"></path>
                      </svg>
                    </span>
                    <input aria-label="Search Bar" autocomplete="off" autocorrect="off" class="form-control input-search" data-custom="true" data-placement="bottom" data-search-suggestions="true" data-suggest="true" data-top="Search new vehicles" name="query" placeholder="Search new vehicles" spellcheck="false" title="Search new vehicles" type="text" value="">
                    <span class="input-group-btn">
                      <button aria-label="search text" class="btn btn-default no-border-left search-submit-btn" type="submit">
                        <svg fill="none" height="34" viewBox="0 0 34 34" width="34" xmlns="http://www.w3.org/2000/svg">
                          <circle cx="17" cy="17" fill="#000000" r="17"></circle>
                          <path d="M17 22.8333V11.1666" stroke="white" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"></path>
                          <path d="M11.1666 17L17 11.1666L22.8333 17" stroke="white" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"></path>
                        </svg>
                      </button>
                    </span>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="tabbed-filter-content">

      <button type="button" class="close tabbed-filter-btn" data-target="#homepageTabbedFilter" data-trigger="close" @click="toggleFilterOpenClose">×</button>
      

      <div class="container-fluid">
      
        <!-- Desktop Filter -->
        <div class="filter-ui">
          <ul class="nav nav-tabs" role="tablist">
            
            <!-- Repeated -->
            <li v-if="isInfiniti || isKia || isCjdr" role="presentation" class="active">
              <a href="#tabShopAllInventory" aria-controls="tabShopAllInventory" role="tab" data-toggle="tab">Shop All Inventory</a>
            </li>
            <li v-else role="presentation" class="active">
              <a href="#tabShopByPayment" aria-controls="tabShopByPayment" role="tab" data-toggle="tab">Shop By Payment</a>
            </li>
            <li v-if="isInfiniti || isKia || isCjdr" role="presentation">
              <a href="#tabShopByPayment" aria-controls="tabShopByPayment" role="tab" data-toggle="tab">Shop By Payment</a>
            </li>
            <li v-else role="presentation">
              <a href="#tabShopAllInventory" aria-controls="tabShopAllInventory" role="tab" data-toggle="tab">Shop All Inventory</a>
            </li>
            <li v-if="!isCjdr" role="presentation">
              <a href="#tabShopByModel" aria-controls="tabShopByModel" role="tab" data-toggle="tab">Shop {{ getBrand }} Models</a>
            </li>
            <li v-else role="presentation">
              <a href="#tabShopByModel" aria-controls="tabShopByModel" role="tab" data-toggle="tab">Shop by Model</a>
            </li>
            <li v-if="!isInfiniti" role="presentation">
              <a href="#tabShopByMake" aria-controls="tabShopByMake" role="tab" data-toggle="tab">Shop All Makes</a>
            </li>

          </ul>
          
          <div class="tab-content">
            
            <!-- Repeated -->
            <div role="tabpanel" class="component-tab-pane tab-pane" :class="{ active: isInfiniti || isKia || isCjdr}" id="tabShopAllInventory">
              
              <div class="mobile-tab-pane-title">
                <a aria-controls="collapseFacetedSearchFilter" aria-expanded="true" class="collapse-tab-pane-content" data-toggle="collapse" href="#collapseFacetedSearchFilter" role="button"> Shop All Inventory <span class="collapse-indicator"><span class="indicator-piece indicator-line indicator-line--top"></span><span class="indicator-piece indicator-circle indicator-circle--top"></span><span class="indicator-piece indicator-line indicator-line--bottom"></span><span class="indicator-piece indicator-circle indicator-circle--bottom"></span></span>
                </a>
              </div>
              
              <div class="tab-pane-content collapse in" id="collapseFacetedSearchFilter">
                <div class="component vehicle-search-form-arbitrary" data-default-new-brand="Kia" data-type-defaults-to-new="true" id="shopByFacetedSearch" data-select-appearance="none">
                  <input class="certification" name="certification" type="hidden" value="">
                  <input class="is_new" name="new" type="hidden" value="true">
                  <div class="search-dropdown first-search-dropdown">
                    <label class="visuallyhidden" for="dropdown-vehicle-type">Select vehicle type:</label>
                    <select aria-labelledby="dropdown-search-title" class="dropdown-vehicle-type form-control filter-item-input vehicle-search vehicle-search-inv-type-arbitrary" data-arbitrary-filter-type="type" data-type="select" name="type" data-results="20">
                      <option value="default">ANY TYPE</option><option value="true">NEW</option><option value="certified">CERTIFIED</option><option value="false">PRE-OWNED</option>
                    </select>
                    <i class="material-icons">keyboard_arrow_down</i>
                  </div>
                  <div class="search-dropdown">
                    <label class="visuallyhidden" for="dropdown-vehicle-year">Select vehicle year:</label>
                    <select aria-labelledby="dropdown-search-title" class="dropdown-vehicle-year form-control filter-item-input vehicle-search vehicle-search-year-arbitrary" data-arbitrary-filter-type="year" data-type="select" name="year" data-results="20">
                      <option value="default">ANY YEAR</option><option value="2026">2026</option>
                    </select>
                    <i class="material-icons">keyboard_arrow_down</i>
                  </div>
                  <div class="search-dropdown">
                    <label class="visuallyhidden" for="dropdown-vehicle-make">Select vehicle make:</label>
                    <select aria-labelledby="dropdown-search-title" class="dropdown-vehicle-make form-control filter-item-input vehicle-search vehicle-search-make-arbitrary" data-arbitrary-filter-type="make" data-type="select" name="make" data-results="20">
                      <option value="default">ANY MAKE</option>
                      <option v-for="brand in brands" :key="brand" value="brand">{{ brand.toUpperCase() }}</option>
                    </select>
                    <i class="material-icons">keyboard_arrow_down</i>
                  </div>
                  <div class="search-dropdown">
                    <label class="visuallyhidden" for="dropdown-vehicle-model">Select vehicle model:</label>
                    <select aria-labelledby="dropdown-search-title" class="dropdown-vehicle-model form-control filter-item-input vehicle-search vehicle-search-model-arbitrary" data-arbitrary-filter-type="model" data-type="select" name="model" data-results="20">
                      <option value="default">ANY MODEL</option>
                      <option v-for="model in models" :key="model" value="model">{{ model }}</option>

                    </select>
                    <i class="material-icons">keyboard_arrow_down</i>
                  </div>
                </div>
              </div>
            </div>

            <div role="tabpanel" class="component-tab-pane tab-pane" :class="{ active: !isInfiniti && !isKia && !isCjdr}" id="tabShopByPayment">
              
              <div class="mobile-tab-pane-title">
                <a class="collapse-tab-pane-content" role="button" data-toggle="collapse" href="#collapsePaymentFilter" aria-expanded="true" aria-controls="collapsePaymentFilter">
                  Shop By Payment
                  <span class="collapse-indicator">
                    <span class="indicator-piece indicator-line indicator-line--top"></span>
                    <span class="indicator-piece indicator-circle indicator-circle--top"></span>
                    <span class="indicator-piece indicator-line indicator-line--bottom"></span>
                    <span class="indicator-piece indicator-circle indicator-circle--bottom"></span>
                  </span>
                </a>
              </div>
              
              <div class="tab-pane-content collapse in" id="collapsePaymentFilter">
                <!-- Nav tabs -->
                <ul class="nav nav-tabs" role="tablist">
                  <li role="presentation" class="active">
                    <a href="#monthlyPaymentFilter" aria-controls="monthlyPaymentFilter" role="tab" data-toggle="tab">Monthly Budget <span data-toggle="tooltip" data-placement="top" title="Projections are based on an 'Excellent' rating - 5.49% APR for 72 months.">*</span></a>
                  </li>
                  <li role="presentation">
                    <a href="#totalPriceFilter" aria-controls="totalPriceFilter" role="tab" data-toggle="tab">Total Price</a>
                  </li>
                </ul>
                
                <!-- Tab panes -->
                <div id="shopByPayment" class="component shop-by-payment">
                  <div class="tab-content">
                    <div role="tabpanel" class="tab-pane sub-component-tab-pane active" id="monthlyPaymentFilter">
                      <div class="tabbed-filter-slider">
                        <input class="js-range-slider filter-item-input" id="monthlyPaymentSlider" type="text" value="" name="max_payment" data-skin="round" data-min="199" data-max="1500" data-from="499" data-step="10" data-prettify-separator="," data-prefix="$">
                      </div>
                    </div>
                    <div role="tabpanel" class="tab-pane sub-component-tab-pane" id="totalPriceFilter">
                      <div class="tabbed-filter-slider">
                        <input class="js-range-slider filter-item-input" id="totalPriceSlider" type="text" value="" name="price" data-skin="round" data-min="10000" data-max="90000" data-from="45000" data-step="1000" data-prettify-separator="," data-prefix="$">
                      </div>
                    </div>
                  </div>
                </div>
              </div>
    
            </div>
            
            <div role="tabpanel" class="component-tab-pane tab-pane" id="tabShopByModel">
              
              <div class="mobile-tab-pane-title">
                <a class="collapse-tab-pane-content" role="button" data-toggle="collapse" href="#collapseModelFilter" aria-expanded="true" aria-controls="collapseModelFilter">
                  {{ isCjdr ? `Shop by Model` : 'Shop ${getBrand} Models' }}
                  <span class="collapse-indicator">
                    <span class="indicator-piece indicator-line indicator-line--top"></span>
                    <span class="indicator-piece indicator-circle indicator-circle--top"></span>
                    <span class="indicator-piece indicator-line indicator-line--bottom"></span>
                    <span class="indicator-piece indicator-circle indicator-circle--bottom"></span>
                  </span>
                </a>
              </div>

              <div class="horizontal-scroll-component tab-pane-content collapse in" id="collapseModelFilter">
                <div id="shopByModel" class="component shop-by-model scroll-parent" data-has-scrollbar="true" data-scroll-region="min">
                  <div class="scroll-horizontal scrollbar-hidden">
                    <!-- Models dynamically inserted here -->
                    <label v-for="sedan in images.sedans" :key="sedan.modelName" class="filter-item" :data-model="sedan.modelName" data-model-attributes="default">
                      <input class="filter-item-input" type="checkbox" name="model" :value="sedan.modelName" data-make="" :data-model="sedan.modelName">
                      <span class="filter-item__img" :style="{backgroundImage: 'url(' + sedan.angleView + ')'}"></span>
                      <span class="filter-item__title" style="background-color: var(--primary-color);">
                        <i class="fa fa-check-circle" aria-hidden="true"></i>
                        {{ getDisplayModel(sedan.modelName) }}
                      </span>
                    </label>
                    <label v-for="suv in images.suvs" :key="suv.modelName" class="filter-item" :data-model="suv.modelName" data-model-attributes="default"><input class="filter-item-input" type="checkbox" name="model" :value="suv.modelName" data-make="" :data-model="suv.modelName"><span class="filter-item__img" :style="{backgroundImage: 'url(' + suv.angleView + ')'}"></span><span class="filter-item__title" style="background-color: var(--primary-color);"><i class="fa fa-check-circle" aria-hidden="true"></i>{{ getDisplayModel(suv.modelName) }}</span></label>
                    <label v-for="truck in images.trucks" :key="truck.modelName" class="filter-item" :data-model="truck.modelName" data-model-attributes="default"><input class="filter-item-input" type="checkbox" name="model" :value="truck.modelName" data-make="" :data-model="truck.modelName"><span class="filter-item__img" :style="{backgroundImage: 'url(' + truck.angleView + ')'}"></span><span class="filter-item__title" style="background-color: var(--primary-color);"><i class="fa fa-check-circle" aria-hidden="true"></i>{{ getDisplayModel(truck.modelName) }}</span></label>
                  </div>
                  <div class="scroll-overlay scroll-overlay--left"></div>
                  <div class="scroll-overlay scroll-overlay--right"></div>
                  <div class="scroll-nav scroll-nav--left">
                    <button
                      type="button"
                      class="scroll-nav-btn"
                      data-scroll-parent="#shopByModel"
                      data-direction="left"
                      tabindex="0"
                    ></button>
                  </div>
                  <div class="scroll-nav scroll-nav--right">
                    <button
                      type="button"
                      class="scroll-nav-btn"
                      data-scroll-parent="#shopByModel"
                      data-direction="right"
                      tabindex="0"
                    ></button>
                  </div>
                </div>
              </div>
              
            </div>
    
            <div role="tabpanel" class="component-tab-pane tab-pane" id="tabShopByMake">

              <div class="mobile-tab-pane-title">
                <a class="collapse-tab-pane-content" role="button" data-toggle="collapse" href="#collapseMakesFilter" aria-expanded="true" aria-controls="collapseMakesFilter">
                  Shop All Makes
                  <span class="collapse-indicator">
                    <span class="indicator-piece indicator-line indicator-line--top"></span>
                    <span class="indicator-piece indicator-circle indicator-circle--top"></span>
                    <span class="indicator-piece indicator-line indicator-line--bottom"></span>
                    <span class="indicator-piece indicator-circle indicator-circle--bottom"></span>
                  </span>
                </a>
              </div>

              <div class="tab-pane-content collapse in" id="collapseMakesFilter">
                <div id="shopByMake" class="component shop-by-make scroll-parent" data-has-scrollbar="true" data-scroll-region="min">
                  <!-- Makes hardcoded here -->
                  <div class="scroll-horizontal scrollbar-hidden"><label class="filter-item" data-make="Acura"><input class="filter-item-input" type="checkbox" name="make" value="Acura" data-make="Acura" data-model=""><span class="filter-item__img" style="background-image: url(https://d2v1gjawtegg5z.cloudfront.net/uploads/files/000/334/478/original/model-fallback-bg-texture-sm.jpg?1672348569);"></span><span class="filter-item__title"><i class="fa fa-check-circle" aria-hidden="true"></i>Acura</span></label><label class="filter-item" data-make="Chevrolet"><input class="filter-item-input" type="checkbox" name="make" value="Chevrolet" data-make="Chevrolet" data-model=""><span class="filter-item__img" style="background-image: url(https://d2v1gjawtegg5z.cloudfront.net/uploads/files/000/334/478/original/model-fallback-bg-texture-sm.jpg?1672348569);"></span><span class="filter-item__title"><i class="fa fa-check-circle" aria-hidden="true"></i>Chevrolet</span></label><label class="filter-item" data-make="Chrysler"><input class="filter-item-input" type="checkbox" name="make" value="Chrysler" data-make="Chrysler" data-model=""><span class="filter-item__img" style="background-image: url(https://d2v1gjawtegg5z.cloudfront.net/uploads/files/000/334/478/original/model-fallback-bg-texture-sm.jpg?1672348569);"></span><span class="filter-item__title"><i class="fa fa-check-circle" aria-hidden="true"></i>Chrysler</span></label><label class="filter-item" data-make="Dodge"><input class="filter-item-input" type="checkbox" name="make" value="Dodge" data-make="Dodge" data-model=""><span class="filter-item__img" style="background-image: url(https://d2v1gjawtegg5z.cloudfront.net/uploads/files/000/334/478/original/model-fallback-bg-texture-sm.jpg?1672348569);"></span><span class="filter-item__title"><i class="fa fa-check-circle" aria-hidden="true"></i>Dodge</span></label><label class="filter-item" data-make="Ford"><input class="filter-item-input" type="checkbox" name="make" value="Ford" data-make="Ford" data-model=""><span class="filter-item__img" style="background-image: url(https://d2v1gjawtegg5z.cloudfront.net/uploads/files/000/334/478/original/model-fallback-bg-texture-sm.jpg?1672348569);"></span><span class="filter-item__title"><i class="fa fa-check-circle" aria-hidden="true"></i>Ford</span></label><label class="filter-item" data-make="GMC"><input class="filter-item-input" type="checkbox" name="make" value="GMC" data-make="GMC" data-model=""><span class="filter-item__img" style="background-image: url(https://d2v1gjawtegg5z.cloudfront.net/uploads/files/000/334/478/original/model-fallback-bg-texture-sm.jpg?1672348569);"></span><span class="filter-item__title"><i class="fa fa-check-circle" aria-hidden="true"></i>GMC</span></label><label class="filter-item" data-make="Honda"><input class="filter-item-input" type="checkbox" name="make" value="Honda" data-make="Honda" data-model=""><span class="filter-item__img" style="background-image: url(https://d2v1gjawtegg5z.cloudfront.net/uploads/files/000/334/478/original/model-fallback-bg-texture-sm.jpg?1672348569);"></span><span class="filter-item__title"><i class="fa fa-check-circle" aria-hidden="true"></i>Honda</span></label><label class="filter-item" data-make="Jeep"><input class="filter-item-input" type="checkbox" name="make" value="Jeep" data-make="Jeep" data-model=""><span class="filter-item__img" style="background-image: url(https://d2v1gjawtegg5z.cloudfront.net/uploads/files/000/334/478/original/model-fallback-bg-texture-sm.jpg?1672348569);"></span><span class="filter-item__title"><i class="fa fa-check-circle" aria-hidden="true"></i>Jeep</span></label><label class="filter-item" data-make="Lexus"><input class="filter-item-input" type="checkbox" name="make" value="Lexus" data-make="Lexus" data-model=""><span class="filter-item__img" style="background-image: url(https://d2v1gjawtegg5z.cloudfront.net/uploads/files/000/334/478/original/model-fallback-bg-texture-sm.jpg?1672348569);"></span><span class="filter-item__title"><i class="fa fa-check-circle" aria-hidden="true"></i>Lexus</span></label><label class="filter-item" data-make="MINI"><input class="filter-item-input" type="checkbox" name="make" value="MINI" data-make="MINI" data-model=""><span class="filter-item__img" style="background-image: url(https://d2v1gjawtegg5z.cloudfront.net/uploads/files/000/334/478/original/model-fallback-bg-texture-sm.jpg?1672348569);"></span><span class="filter-item__title"><i class="fa fa-check-circle" aria-hidden="true"></i>MINI</span></label><label class="filter-item" data-make="Mitsubishi"><input class="filter-item-input" type="checkbox" name="make" value="Mitsubishi" data-make="Mitsubishi" data-model=""><span class="filter-item__img" style="background-image: url(https://d2v1gjawtegg5z.cloudfront.net/uploads/files/000/334/478/original/model-fallback-bg-texture-sm.jpg?1672348569);"></span><span class="filter-item__title"><i class="fa fa-check-circle" aria-hidden="true"></i>Mitsubishi</span></label><label class="filter-item" data-make="Nissan"><input class="filter-item-input" type="checkbox" name="make" value="Nissan" data-make="Nissan" data-model=""><span class="filter-item__img" style="background-image: url(https://d2v1gjawtegg5z.cloudfront.net/uploads/files/000/334/478/original/model-fallback-bg-texture-sm.jpg?1672348569);"></span><span class="filter-item__title"><i class="fa fa-check-circle" aria-hidden="true"></i>Nissan</span></label><label class="filter-item" data-make="Ram"><input class="filter-item-input" type="checkbox" name="make" value="Ram" data-make="Ram" data-model=""><span class="filter-item__img" style="background-image: url(https://d2v1gjawtegg5z.cloudfront.net/uploads/files/000/334/478/original/model-fallback-bg-texture-sm.jpg?1672348569);"></span><span class="filter-item__title"><i class="fa fa-check-circle" aria-hidden="true"></i>Ram</span></label><label class="filter-item" data-make="Subaru"><input class="filter-item-input" type="checkbox" name="make" value="Subaru" data-make="Subaru" data-model=""><span class="filter-item__img" style="background-image: url(https://d2v1gjawtegg5z.cloudfront.net/uploads/files/000/334/478/original/model-fallback-bg-texture-sm.jpg?1672348569);"></span><span class="filter-item__title"><i class="fa fa-check-circle" aria-hidden="true"></i>Subaru</span></label><label class="filter-item" data-make="Toyota"><input class="filter-item-input" type="checkbox" name="make" value="Toyota" data-make="Toyota" data-model=""><span class="filter-item__img" style="background-image: url(https://d2v1gjawtegg5z.cloudfront.net/uploads/files/000/334/478/original/model-fallback-bg-texture-sm.jpg?1672348569);"></span><span class="filter-item__title"><i class="fa fa-check-circle" aria-hidden="true"></i>Toyota</span></label><label class="filter-item" data-make="Volkswagen"><input class="filter-item-input" type="checkbox" name="make" value="Volkswagen" data-make="Volkswagen" data-model=""><span class="filter-item__img" style="background-image: url(https://d2v1gjawtegg5z.cloudfront.net/uploads/files/000/334/478/original/model-fallback-bg-texture-sm.jpg?1672348569);"></span><span class="filter-item__title"><i class="fa fa-check-circle" aria-hidden="true"></i>Volkswagen</span></label><label class="filter-item" data-make="Volvo"><input class="filter-item-input" type="checkbox" name="make" value="Volvo" data-make="Volvo" data-model=""><span class="filter-item__img" style="background-image: url(https://d2v1gjawtegg5z.cloudfront.net/uploads/files/000/334/478/original/model-fallback-bg-texture-sm.jpg?1672348569);"></span><span class="filter-item__title"><i class="fa fa-check-circle" aria-hidden="true"></i>Volvo</span></label></div>

                  <div class="scroll-overlay scroll-overlay--left"></div>
                  <div class="scroll-overlay scroll-overlay--right"></div>
                  <div class="scroll-nav scroll-nav--left">
                    <button
                      type="button"
                      class="scroll-nav-btn"
                      data-scroll-parent="#shopByMake"
                      data-direction="left"
                      tabindex="0"
                    ></button>
                  </div>
                  <div class="scroll-nav scroll-nav--right">
                    <button
                      type="button"
                      class="scroll-nav-btn"
                      data-scroll-parent="#shopByMake"
                      data-direction="right"
                      tabindex="0"
                    ></button>
                  </div>
                </div>
              </div>

            </div>

            <a class="results-placeholder-link sokal-flex sokal-items-center sokal-justify-center" href="/vehicles?filter=start_payment-0.end_payment-499">
              <span class="placeholder-count">172</span>
              <span class="placeholder-text">Results</span>
              <svg fill="none" height="34" viewBox="0 0 34 34" width="34"
                xmlns="http://www.w3.org/2000/svg">
                <circle cx="17" cy="17" fill="white" r="17" transform="rotate(90 17 17)"></circle>
                <path d="M11.1668 17H22.8335" stroke="#000000" stroke-linecap="round" stroke-linejoin="round"
                  stroke-width="2"></path>
                <path d="M17.0002 11.1667L22.8335 17.0001L17.0002 22.8334" stroke="#000000" stroke-linecap="round"
                  stroke-linejoin="round" stroke-width="2"></path>
              </svg>
            </a>
            <div role="tabpanel" class="results-tab-pane tab-pane" id="tabShopByResults">
              <a href="#" class="btn-branded shop-by-results-btn">
                <!-- CJDR version -->
                <template v-if="isCjdr">
                  <span class="results-preview">
                    <span class="results-count">20</span>
                  </span>
                  <span class="results-btn-txt">Results</span>
                  <svg fill="none" height="34" viewBox="0 0 34 34" width="34"
                    xmlns="http://www.w3.org/2000/svg">
                    <circle cx="17" cy="17" fill="white" r="17" transform="rotate(90 17 17)"></circle>
                    <path d="M11.1668 17H22.8335" stroke="#000000" stroke-linecap="round" stroke-linejoin="round"
                      stroke-width="2"></path>
                    <path d="M17.0002 11.1667L22.8335 17.0001L17.0002 22.8334" stroke="#000000" stroke-linecap="round"
                      stroke-linejoin="round" stroke-width="2"></path>
                  </svg>
                </template>

                <!-- Default version -->
                <template v-else>
                  <span class="results-btn-txt">View Results </span>
                  <span class="results-preview">
                    (<span class="results-count">20</span>)
                  </span>
                </template>
              </a>
              <input class="max-payment-results" name="max_payment_results" type="hidden" data-component="#monthlyPaymentFilter" readonly value="0">
              <input class="max-price-results" name="price_results" type="hidden" data-component="#totalPriceFilter" readonly value="0">
              <input class="model-results" name="model_results" type="hidden" data-component="#tabShopByModel" readonly value="0">
              <input class="make-results" name="make_results" type="hidden" data-component="#tabShopByMake" readonly value="0">
            </div>
    
          </div>
    
        </div>
    
      </div>

    </div>

  </div>
</template>

<!-- Bootstrap JS (v3) -->
<script src="https://stackpath.bootstrapcdn.com/bootstrap/3.4.1/js/bootstrap.min.js" integrity="sha384-aJ21OjlMXNL5UyIl/XNwTMqvzeRMZH2w8c5cRVpzpU8Y5bApTppSuUkhZXN0VxHd" crossorigin="anonymous"></script>

<script>
import "../../static/bootstrap-3.3.7-dist/js/bootstrap.min.js";
import screenMixin from '../mixins/screenMixin';
import horizontalScroll from '../helpers/horizontalScroll'

export default {
  mixins: [screenMixin],
  props: ['images'],
  data() {
    return {
      brand: this.$store.state.chosenBrand,
      isFilterOpen: false,
    }
  },
  computed: {
    getBrand () {
      if (this.brand.toLowerCase() === 'none') {
        return 'Brand';
      } else {
        return this.brand.substr(0,1).toUpperCase() + this.brand.substr(1);
      }
    },
     brands() {
      if (this.isCjdr) {
        return ['DODGE', 'CHRYSLER', 'JEEP', 'RAM'];
      }

      return [this.getBrand.toUpperCase()];
    },
    models() {
      if (!this.images) return [];

      const result = [];
      const perCategory = this.isCjdr ? 2 : 1;

      Object.keys(this.images).forEach(category => {
        const items = this.images[category];

        if (Array.isArray(items)) {
          result.push(
            ...items
              .slice(0, perCategory)
              .filter(m => m && m.modelName)
              .map(m => m.modelName.toUpperCase())
          );
        }
      });

      return result;
    },
    isKia () {
      if (this.brand.toLowerCase() === 'kia') {
        return true;
      } else {
        return false;
      }
    },
    isInfiniti () {
      if (this.brand.toLowerCase() === 'infiniti') {
        return true;
      } else {
        return false;
      }
    },
    isCjdr () {
      if (this.brand.toLowerCase() === 'cjdr') {
        return true;
      } else {
        return false;
      }
    },
    parentFilterClass() {
      return this.isMobile960 ? "homepage-tabbed-filter--mobile" : "";
    },
  }, 
  watch: {
    isMobile960() {
      this.toggleMobileDisplay();
      this.limitMobileCollapse();
    },
    isResizedDesktop() {
      this.limitMobileCollapse();
    }
  },
  mounted () {
    this.init();
    this.toggleMobileDisplay();
    horizontalScroll.init();
  },
  
  beforeDestroy() {
    horizontalScroll.destroy()
  },

  methods: {
    init () {
      this.createIrsInstances();
      this.initTooltip();
      this.populateMakes();
      this.displayMakeModelResults();
      this.modalEventFunctions();
      this.toggleMobileDisplay();
      this.toggleFilterOpenClose();
      this.limitMobileCollapse();
    }, 

    returnBrand () {
      if (this.brand.toLowerCase() === 'none') {
        return 'Default';
      } else {
        return this.brand.substr(0,1).toUpperCase() + this.brand.substr(1);
      }
    },
    
    getDisplayModel(modelName) {
      if (!this.isCjdr) return modelName

      const makes = ['dodge', 'jeep', 'ram', 'chrysler']

      return modelName
        .split(' ')
        .filter(word => !makes.includes(word.toLowerCase()))
        .join(' ')
    },

    createIrsInstances () {
      const targetObj = {
        'component': '#tabShopByPayment', 
        'inputType': 'range'
      };

      $('.homepage-tabbed-filter .js-range-slider').ionRangeSlider({
        onStart: function(data) {
          // Add start functions here
        }, 
        onFinish: function(data) {
          $(data.input).closest('.component-tab-pane').attr('data-is-active', 'true');
          $('#homepageTabbedFilter .filter-ui > .tab-content:not(.display-results)').addClass('display-results');

          const dataSet = 200;
          const dataMax = data.max;
          const dataVal = $(data.input).val();
          const results = Math.floor((dataVal / dataMax) * dataSet);
          
          // $('#homepageTabbedFilter .display-results #tabShopByPayment.active ~ .results-placeholder-link').css('display', 'none');
          $('#homepageTabbedFilter #tabShopByResults .shop-by-results-btn .results-count').text(results);
          $('#homepageTabbedFilter #tabShopByResults .shop-by-results-btn .results-count').attr('data-results-count', results);
          
        }
      });
    }, 

    initTooltip () {
      $('#homepageTabbedFilter [data-toggle="tooltip"]').tooltip();
    }, 

    populateModels () {
      const modelsMax = 11;
      let template;
      let make = this.returnBrand();
      let modelName;

      for (let i=1; i < modelsMax; i++) {
        modelName = make + ' Model ' + i;
        template = `<label class="filter-item" data-model="${modelName}" data-model-attributes="default"><input class="filter-item-input" type="checkbox" name="model" value="${modelName}" data-make="" data-model="${modelName}"><span class="filter-item__img" style="background-color: var(--primary-color); background-image: url(https://d2v1gjawtegg5z.cloudfront.net/uploads/files/000/334/478/original/model-fallback-bg-texture-sm.jpg?1672348569);"></span><span class="filter-item__title" style="background-color: var(--primary-color);"><i class="fa fa-check-circle" aria-hidden="true"></i>${modelName}</span></label>`;
        
        $('#homepageTabbedFilter #shopByModel .scroll-horizontal').append(template);
      }
    }, 

    populateMakes () {
      let make = this.returnBrand();
      let isNotDefaultBrand = this.returnBrand() != 'Default';

      if (isNotDefaultBrand) {
        $(`#homepageTabbedFilter #shopByMake .filter-item[data-make="${make}"]`).prependTo($('#homepageTabbedFilter #shopByMake .scroll-horizontal'));
      }
    }, 

    displayMakeModelResults () {
      $('#homepageTabbedFilter #shopByMake .filter-item, #homepageTabbedFilter #shopByModel .filter-item, #homepageTabbedFilter #shopByFacetedSearch .filter-item-input').on('change', function(){
        const hasActiveItems = $(this).parent().find(':checked').length > 0;
        let activeItemCount = $(this).parent().find(':checked').length;

        if (hasActiveItems) {
          $(this).closest('.component-tab-pane').attr('data-is-active', 'true');
          $('#homepageTabbedFilter .filter-ui > .tab-content:not(.display-results)').addClass('display-results');
        } else {
          $(this).closest('.component-tab-pane').attr('data-is-active', 'false');
        }

        $('#homepageTabbedFilter .display-results #tabShopAllInventory.active ~ .results-placeholder-link').css('display', 'none');
        $('#homepageTabbedFilter #tabShopByResults .shop-by-results-btn .results-count').text(activeItemCount);
        $('#homepageTabbedFilter #tabShopByResults .shop-by-results-btn .results-count').attr('data-results-count', activeItemCount);

      });
    },
    modalEventFunctions () {
      
      $('#tabbedFilterModal').on('show.bs.modal', function() {
        const yState = $('.homepage-tabbed-filter .tabbed-filter-btn.close').data('return-scroll-y');
        $(document).bind('scroll',function () { 
          window.scrollTo({top: yState});
        });
      });
      $('#tabbedFilterModal').on('hidden.bs.modal', function() {
        $(document).unbind('scroll');
      });
    },
    collapseInactiveTabs (object) {
      $(object.parentFilter + ' .filter-ui > .nav-tabs li:not(.active)').each(function(){
        let tab = $(this).find('a').attr('href');
        $(tab).find('.tab-pane-content').collapse(object.collapseOption);
      });
    },
    limitMobileCollapse () {
      const isMobile = this.isMobile960; 
      const isResize = this.isResizedDesktop; 

      $('.homepage-tabbed-filter .component-tab-pane').each(function() {
        if (isMobile && !$(this).hasClass('active')) {
          $(this).find('.tab-pane-content').collapse('hide');
        } else if (isResize && $(this).hasClass('active')) {
          $(this).find('.tab-pane-content').collapse('show');
        }
      });
      $('.homepage-tabbed-filter .collapse-tab-pane-content').click(function(){
        if ( $(this).attr('aria-expanded') === 'true') {
          return false;
        }
        
        const target = $(this).attr('href');
        $('.homepage-tabbed-filter .tab-pane-content:not(' + target + ')').collapse('hide');

        const parentTabPane = $(this).closest('.component-tab-pane').attr('id');
        $('.homepage-tabbed-filter a[href="#' + parentTabPane + '"]').click();
      });
    },
    toggleMobileDisplay () {
      if (this.isMobile960) {
        this.isFilterOpen = false;
      }
    },
    toggleFilterOpenClose () {
      this.isFilterOpen = !this.isFilterOpen;
    }
  }
};
</script>

<style
  scoped
  src="../../static/bootstrap-3.3.7-dist/css/bootstrap.min.css"
></style>

<style scoped>
  /* Branded button styles */

  body .btn-branded {
    display: inline-block;
    background-color: transparent;
    color: #ffffff;
    border: solid 1px #ffffff;
    border-radius: 50px;
    padding: 12px 20px;
    font-weight: normal;
    text-align: center;
    white-space: nowrap;
    vertical-align: middle;
    touch-action: manipulation;
    cursor: pointer;
    background-image: none;
    font-size: 14px;
    line-height: 1.428571429;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    -webkit-transition: all 0.3s ease;
    -moz-transition: all 0.3s ease;
    transition: all 0.3s ease;
  }
  body .btn-branded:hover, 
  body .btn-branded:active, 
  body .btn-branded:focus {
    background-color: #ffffff;
    border-color: var(--primary-dark);
    color: var(--primary-dark);
  }

  body .btn-branded--fill {
    background-color: var(--primary-color);
    border-color: var(--primary-color);
    color: #ffffff;
  }

  body .btn-branded--fill:hover, 
  body .btn-branded--fill:active, 
  body .btn-branded--fill:focus {
    background-color: #ffffff;
    border-color: var(--primary-color);
    color: var(--primary-color);
  }

  body .homepage-tabbed-filter[data-brand="Cjdr"]  .btn-branded--fill {
    background-color: var(--secondary-color);
    border-color: var(--secondary-color);
  }

  body .homepage-tabbed-filter[data-brand="Cjdr"]  .btn-branded--fill:hover, 
  body .homepage-tabbed-filter[data-brand="Cjdr"]  .btn-branded--fill:active, 
  body .homepage-tabbed-filter[data-brand="Cjdr"]  .btn-branded--fill:focus {
    border-color: var(--secondary-color);
    color: var(--secondary-color);
  }

  /* Utility Styles */
                
  .pad-l-15 {
    padding-left: 15px;
  }

  .margin-top-xs {
    margin-top: 7px;
  }

  .flex-row-start, 
  .flex-row-center,  
  .flex-row-center-start, 
  .flex-row-center-between {
    display: flex;
    flex-direction: row;
  }

  .flex-row-start {
    align-items: flex-start;
    justify-content: flex-start;
  }

  .flex-row-center {
    align-items: center;
    justify-content: center;
  }

  .flex-row-center-start {
    align-items: center;
    justify-content: flex-start;
  }

  .flex-row-center-between {
    align-items: center;
    justify-content: space-between;
  }

  .horizontal-scroll {
    overflow-x: auto;
    white-space: nowrap;
  }

  .scrollbar-hidden {
    -ms-overflow-style: none;
    scrollbar-width: none;
  }

  .scrollbar-hidden::-webkit-scrollbar {
    display: none;
  }
  
  .component-space {
    margin-top: 15px;
    margin-bottom: 15px;
  }

  .component-title {
    display: inline-block;
    margin: 10px 0px 15px 0px;
    font-size: 18px;
  }

  .homepage-tabbed-filter .component .scroll-horizontal > *:first-child {
    margin-left: 15px;
  }

  .homepage-tabbed-filter .scroll-overlay--left {
    background: linear-gradient(to left, rgba(255, 255, 255, 0) 0%, 45%, #ffffff 100%);
  }

  .homepage-tabbed-filter .scroll-overlay--right {
    background: linear-gradient(to right, rgba(255, 255, 255, 0) 0%, 45%,#ffffff 100%);
  }

  .homepage-tabbed-filter .scroll-nav--left {
    padding-left: 1.5%;
  }

  .homepage-tabbed-filter .scroll-nav--right {
    padding-right: 1.5%;
  }
  .visuallyhidden {
    position: absolute !important;
    overflow: hidden !important;
    clip: rect(0 0 0 0) !important;
    height: 1px !important;
    width: 1px !important;
    margin: -1px !important;
    padding: 0 !important;
    border: 0 !important
  }

  .modal-open {
    overflow: hidden;
    height: 100%;
}
.modal {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1050;
    display: none;
    overflow: hidden;
    -webkit-overflow-scrolling: touch;
    outline: 0;
}
.modal.fade .modal-dialog {
    -webkit-transform: translate(0, -25%);
    -ms-transform: translate(0, -25%);
    -o-transform: translate(0, -25%);
    transform: translate(0, -25%);
    -webkit-transition: -webkit-transform 0.3s ease-out;
    -moz-transition: -moz-transform 0.3s ease-out;
    -o-transition: -o-transform 0.3s ease-out;
    transition: transform 0.3s ease-out;
}
.modal.in .modal-dialog {
    -webkit-transform: translate(0, 0);
    -ms-transform: translate(0, 0);
    -o-transform: translate(0, 0);
    transform: translate(0, 0);
}
.modal-open .modal {
    overflow-x: hidden;
    overflow-y: auto;
}
.modal-dialog {
    position: relative;
    width: auto;
    margin: 10px;
}
.modal-content {
    position: relative;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid #999;
    border: 1px solid rgba(0,0,0,0.2);
    border-radius: 6px;
    -webkit-box-shadow: 0 3px 9px rgba(0,0,0,0.5);
    box-shadow: 0 3px 9px rgba(0,0,0,0.5);
    outline: 0;
}
.modal-backdrop.fade {
    filter: alpha(opacity=0);
    opacity: 0;
}
.modal-backdrop.in {
    filter: alpha(opacity=50);
    opacity: 0.5;
}
.modal-header:before,.modal-header:after {
    display: table;
    content: " ";
}
.modal-header:after {
    clear: both;
}
.modal-header .close {
    margin-top: -2px;
}
.modal-title {
    margin: 0;
    line-height: 1.428571429;
}
.modal-body {
    position: relative;
    padding: 15px;
}
.modal-scrollbar-measure {
    position: absolute;
    top: -9999px;
    width: 50px;
    height: 50px;
    overflow: scroll;
}

@media (min-width: 768px) {
    .modal-dialog {
        width:600px;
        margin: 30px auto;
    }
    .modal-content {
        -webkit-box-shadow: 0 5px 15px rgba(0,0,0,0.5);
        box-shadow: 0 5px 15px rgba(0,0,0,0.5);
    }
}

  /* Component Classes */

  .homepage-tabbed-filter .scroll-parent {
    position: relative;
    width: 100%;
    margin: 0 auto;
  }
  .homepage-tabbed-filter .scroll-horizontal {
    position: relative;
    background-color: #ffffff;
    overflow-x: scroll;
    width: 100%;
    margin: 0 auto;
    white-space: nowrap;
    -ms-overflow-style: none;
    scrollbar-width: none;
  }
  .homepage-tabbed-filter .scroll-horizontal::-webkit-scrollbar {
    display: none;
  }
  .homepage-tabbed-filter .scroll-horizontal > * {
    display: inline-block;
    white-space: normal;
    vertical-align: text-top;
  }
  .homepage-tabbed-filter .scroll-overlay, 
  .homepage-tabbed-filter .scroll-nav {
    width: 15%;
    height: 100%;
    position: absolute;
    top: 0;
    -webkit-transition: all 0.1s ease;
    -moz-transition: all 0.1s ease;
    -o-transition: all 0.1s ease;
    transition: all 0.1s ease;
  }
  .homepage-tabbed-filter .scroll-overlay--left {
    left: 0;
    background: linear-gradient(to left, rgba(255, 255, 255, 0) 0%, 5%, #ffffff 100%);
  }
  .homepage-tabbed-filter .scroll-overlay--right {
    right: 0;
    background: linear-gradient(to right, rgba(255, 255, 255, 0) 0%, 5%,#ffffff 100%);
  }
  .homepage-tabbed-filter .scroll-nav {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .homepage-tabbed-filter .scroll-nav--right {
    right: 0;
    align-items: flex-end;
    padding-right: 3%;
  }
  .homepage-tabbed-filter .scroll-nav--left {
    left: 0;
    align-items: flex-start;
    padding-left: 3%;
  }
  .homepage-tabbed-filter .scroll-nav-btn {
    font-size: inherit;
    font-weight: 300;
    width: 30px;
    height: 30px;
    color: #ffffff;
    background-color: transparent;
    border: solid 2px #000000;
    border-radius: 100%;
    -webkit-transition: all 0.3s ease;
    -moz-transition: all 0.3s ease;
    -o-transition: all 0.3s ease;
    transition: all 0.3s ease;
    background-image: url(https://d2v1gjawtegg5z.cloudfront.net/uploads/files/000/309/654/original/toyota-arrow-right-black.png?1669999978);
    background-size: 35%;
    background-position: center;
    background-repeat: no-repeat;
  }
  .homepage-tabbed-filter .scroll-nav--left .scroll-nav-btn {
    transform: rotateY(180deg);
  }
  .homepage-tabbed-filter .scroll-nav-btn:hover {
    opacity: 0.7;
  }
  .homepage-tabbed-filter .scroll-nav-btn:focus,
  .homepage-tabbed-filter .scroll-nav-btn:active {
    color: #101010;
    border-color: #101010;
    -webkit-transform: scale(1.5);
    transform: scale(1.5);
  }
  .homepage-tabbed-filter .scroll-nav--left .scroll-nav-btn:focus, 
  .homepage-tabbed-filter .scroll-nav--left .scroll-nav-btn:active {
    -webkit-transform: rotateY(180deg) scale(1.5);
    transform: rotateY(180deg) scale(1.5);
  }
  .homepage-tabbed-filter .scroll-parent[data-scroll-region="min"] .scroll-overlay--left,
  .homepage-tabbed-filter .scroll-parent[data-scroll-region="max"] .scroll-overlay--right,
  .homepage-tabbed-filter .scroll-parent[data-scroll-region="min"] .scroll-nav--left,
  .homepage-tabbed-filter .scroll-parent[data-scroll-region="max"] .scroll-nav--right {
    opacity: 0;
    visibility: hidden;
  }
  @media (max-width: 767px) {
    .homepage-tabbed-filter .scroll-parent {
      width: 90vw;
    }
    .homepage-tabbed-filter .scroll-nav--right {
      right: -3%;
    }
    .homepage-tabbed-filter .scroll-nav--left {
      left: -3%;
    }
    .homepage-tabbed-filter .scroll-nav-btn:hover,
    .homepage-tabbed-filter .scroll-nav-btn:active,
    .homepage-tabbed-filter .scroll-nav-btn:focus {
      opacity: 1;
      color: #101010;
      border-color: #101010;
      -webkit-transform: scale(1.3);
      transform: scale(1.3);
    }
    .homepage-tabbed-filter .scroll-nav--left .scroll-nav-btn:hover,
    .homepage-tabbed-filter .scroll-nav--left .scroll-nav-btn:active,
    .homepage-tabbed-filter .scroll-nav--left .scroll-nav-btn:focus {
      -webkit-transform: rotateY(180deg) scale(1.3);
      transform: rotateY(180deg) scale(1.3);
    }
  }

  /* Kia */

  .homepage-tabbed-filter:not([data-brand="Toyota"]) .scroll-nav-btn {
    border: none;
  }

  /* Global Styles */

  .tabbed-filter-content {
    background: #ffffff;
  }

  .homepage-tabbed-filter {
    padding-top: 12px;
  }

  .homepage-tabbed-filter  .nav-tabs {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    border-bottom: 0;
  }

  .homepage-tabbed-filter .nav-tabs>li {
    float: none;
    display: inline-block;
    margin-bottom: 0px;
  }

  .homepage-tabbed-filter .nav-tabs>li>a {
    margin: 0px 20px;
    padding: 5px 0px;
    opacity: 0.2;
    border: 0;
    border-radius: 0;
    color: var(--primary-dark);
    font-size: 16px;
  }

  .homepage-tabbed-filter .nav-tabs>li.active>a {
    color: var(--primary-dark);
    background-color: #ffffff;
    border: 0;
    opacity: 1;
  }

  .homepage-tabbed-filter .nav-tabs>li>a:hover, 
  .homepage-tabbed-filter .nav-tabs>li>a:active, 
  .homepage-tabbed-filter .nav-tabs>li>a:focus {
    background-color: #ffffff;
    color: var(--primary-dark);
    border: 0 !important;
    opacity: 1;
    outline: none;
  }

  .homepage-tabbed-filter .tab-content {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    height: 80px;
    margin: 10px auto;
    padding: 0 20px;
  }

  .homepage-tabbed-filter .tab-content .nav-tabs {
    border: 2px solid #E5E5E5;
    padding: 7.5px;
    border-radius: 10px;
    margin-left: 15px;
  }

  .homepage-tabbed-filter .filter-ui > .tab-content {
    justify-content: flex-start;
  }

  .homepage-tabbed-filter .filter-ui > .tab-content > .tab-pane {
    width: 100%;
    margin-left: 0;
    margin-right: 0;
    -webkit-transition: width 0.2s ease;
    -moz-transition: width 0.2s ease;
    transition: width 0.2s ease;
  }

  .homepage-tabbed-filter:not(.homepage-tabbed-filter--mobile) .filter-ui > .tab-content.display-results > .tab-pane.active[data-is-active="true"] {
    display: inline-flex;
    width: 80%;
    max-width: calc(100% - 200px);
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }

  .homepage-tabbed-filter .filter-ui > .tab-content.display-results #tabShopByResults {
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .homepage-tabbed-filter:not(.homepage-tabbed-filter--mobile) .filter-ui > .tab-content.display-results #tabShopByResults {
    background-color: #000000;
    min-width: 200px;
    width: 20%;
    margin-right: 15px;
  }

  .homepage-tabbed-filter .filter-ui > .tab-content.display-results .component-tab-pane.active[data-is-active="true"] ~ #tabShopByResults {
    display: inline-flex;
  }

  .homepage-tabbed-filter .tab-pane {
    width: 100%;
    height: 100%;
    border-radius: 10px;
  }

  .homepage-tabbed-filter .tab-pane.active {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }

  .homepage-tabbed-filter .js-range-slider {
    opacity: 0;
  }

  /* Shop By Payment */

  .homepage-tabbed-filter .tab-pane .tab-content {
    height: fit-content;
    width: 100%;
    margin: 0;
    padding: 0;
  }
  
  .homepage-tabbed-filter .tab-pane .tab-content .tab-pane {
    border: 0;
    border-radius: 0;
  }

  .homepage-tabbed-filter:not(.homepage-tabbed-filter--mobile) .tab-pane .nav-tabs, 
  .homepage-tabbed-filter:not(.homepage-tabbed-filter--mobile) .tab-pane .component {
    display: inline-flex;
  }

  #tabShopByPayment > .nav-tabs {
    width: 400px;
    max-width: 60%;
    border: 2px solid #E5E5E5;
    padding: 7.5px;
    border-radius: 10px;
    margin-left: 15px;
  }

  #tabShopByPayment .nav-tabs li > a {
    border-bottom: solid 2px transparent !important;
    background-color: transparent;
    margin: 0 15px 0 10px;
  }

  #tabShopByPayment .nav-tabs li.active > a {
    border-bottom-color: var(--primary-dark) !important;
    background-color: var(--primary-dark);
    color: #ffffff;
    padding: 8px 12px;
    border-radius: 6px;
    margin: 0;
  }

  #tabShopByPayment .component.shop-by-payment {
    width: 100%;
    max-width: 40%;
  }

  #tabShopByPayment .tabbed-filter-slider {
    width: 100%;
  }

  .themed-slider {
    -webkit-appearance: none;
    appearance: none;
    width: 100%;
    height: 2px;
    background: var(--primary-dark);
    outline: none;
  }

  .themed-slider::-webkit-slider-thumb {
    -webkit-appearance: none;
    appearance: none;
  }

  .themed-slider::-webkit-slider-thumb {
    -webkit-appearance: none;
    appearance: none;
    width: 25px;
    height: 25px;
    background: radial-gradient(#EB0A1E 20%,#ffffff 20%, #ffffff 45%, #EB0A1E 45%, #EB0A1E 55%, #ffffff 55%);
    border-radius: 50%;
    cursor: pointer;
  }

  .themed-slider::-moz-range-thumb {
    width: 25px;
    height: 25px;
    background: radial-gradient(#EB0A1E 20%,#ffffff 20%, #ffffff 45%, #EB0A1E 45%, #EB0A1E 55%, #ffffff 55%);
    border-radius: 50%;
    cursor: pointer;
  }

  #payment-preview p {
    margin: 0px;
    text-align: center;
    font-size: 23px;
    margin-top: -4px;
  }

  /* Ion Range Slider */

  .homepage-tabbed-filter .irs {
    font-family: inherit;
  }

  .homepage-tabbed-filter .irs--round .irs-single {
    background-color: transparent;
    color: var(--primary-dark);
    text-shadow: 0 0 var(--primary-dark);
  }

  .homepage-tabbed-filter .irs--round .irs-single::before {
    border: 0;
  }
  
  .homepage-tabbed-filter .irs--round .irs-line, 
  .homepage-tabbed-filter .irs--round .irs-bar {
    height: 4px;
  }

  .homepage-tabbed-filter .irs--round .irs-bar {
    background-color: var(--primary-color);
    background: var(--primary-color);
    border-color: var(--primary-color);
  }

  .homepage-tabbed-filter .irs--round .irs-handle {
    border: 0;
    border-color: #ffffff;
    background: radial-gradient(var(--primary-color) 25%,#ffffff 28%, #ffffff 50%, var(--primary-color) 53%, var(--primary-color) 60%, #ffffff 63%, #ffffff 100%);
    box-shadow: none;
  }

  .homepage-tabbed-filter[data-brand="Cjdr"] .irs--round .irs-bar {
    background-color: var(--secondary-color);
    background: var(--secondary-color);
    border-color: var(--secondary-color);
  }

  .homepage-tabbed-filter[data-brand="Cjdr"] .irs--round .irs-handle {
    background: radial-gradient(var(--secondary-color) 25%,#ffffff 28%, #ffffff 50%, var(--secondary-color) 53%, var(--secondary-color) 60%, #ffffff 63%, #ffffff 100%);
  }

  .homepage-tabbed-filter .irs--round .irs-min, 
  .homepage-tabbed-filter .irs--round .irs-max {
    background: transparent;
    color: #999999;
  }

  .homepage-tabbed-filter .irs--round .irs-line:hover, 
  .homepage-tabbed-filter .irs--round .irs-bar:hover, 
  .homepage-tabbed-filter .irs--round .irs-handle:hover {
    cursor: pointer;
  }

  /* Shop By Model */

  .homepage-tabbed-filter .scroll-overlay, 
  .homepage-tabbed-filter .scroll-nav {
    min-width: 70px;
    width: 7%;
  }
  
  .homepage-tabbed-filter .filter-item {
    white-space: normal;
    position: relative;
    display: inline-flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    width: 250px;
    height: 100px;
    margin-right: 10px;
    margin-bottom: 0px;
    text-align: center;
    cursor: pointer;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }
  
  .homepage-tabbed-filter .filter-item input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
  }
  
  .homepage-tabbed-filter .filter-item__img {
    display: inline-block;
    box-sizing: border-box;
    background-size: cover;
    background-position: left center;
    background-color: #efefef;
    background-repeat: no-repeat;
    width: 60%;
    height: 85%;
    border-radius: 6px 0 0 6px;
    -webkit-transition: all 0.2s ease-out;
    -moz-transition: all 0.2s ease-out;
    transition: all 0.2s ease-out;
  }
  
  .homepage-tabbed-filter .filter-item input:checked ~ .filter-item__img {
    background-blend-mode: luminosity;
    filter: brightness(0.7);
  }

  /* .homepage-tabbed-filter[data-brand="Cjdr"] .shop-by-model .filter-item__img {
    background-color: var(--secondary-color) !important;
  } */
  
  .homepage-tabbed-filter .filter-item__title {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 40%;
    height: 85%;
    text-align: left;
    font-weight: bold;
    font-size: 14px;
    padding: 15px;
    color: #ffffff;
    border-radius: 0px 6px 6px 0;
  }

  /* .homepage-tabbed-filter[data-brand="Cjdr"] .shop-by-model .filter-item__title {
    background-color: var(--secondary-color) !important;
  } */
  
  .homepage-tabbed-filter .filter-item__title .fa-check-circle {
    color: #ffffff;
    display: none;
    position: absolute;
    top: 50%;
    right: 60%;
    transform: translateY(-50%);
    font-size: 45px;
  }
  
  .homepage-tabbed-filter .filter-item-input:checked ~ .filter-item__title .fa-check-circle {
    display: inline;
  }

  .homepage-tabbed-filter .filter-item__title .dynamic-results {
    display: none;
    position: absolute;
    top: 11%;
    left: 3%;
    -webkit-backdrop-filter: blur(2px);
    backdrop-filter: blur(2px);
    padding: 0 5px;
  }

  .homepage-tabbed-filter .filter-item-input:checked ~ .filter-item__title .dynamic-results {
    display: inline;
  }

  /* Shop By Make */

  .shop-by-make .filter-item__title, 
  .shop-by-make .filter-item__img {
    background-color: var(--primary-color);
  }

  .shop-by-make .filter-item__img {
    background-blend-mode: luminosity;
  }

  /* Make - Acura */

  .shop-by-make .filter-item[data-make="Acura"] .filter-item__title, 
  .shop-by-make .filter-item[data-make="Acura"] .filter-item__img {
    background-color: #000000;
  }
  
  /* Make - Alfa Romeo */

  .shop-by-make .filter-item[data-make="Alfa Romeo"] .filter-item__title, 
  .shop-by-make .filter-item[data-make="Alfa Romeo"] .filter-item__img {
    background-color: #035642;
  }
  
  /* Make - Audi */

  .shop-by-make .filter-item[data-make="Audi"] .filter-item__title, 
  .shop-by-make .filter-item[data-make="Audi"] .filter-item__img {
    background-color: #f50537;
  }
  
  /* Make - BMW */

  .shop-by-make .filter-item[data-make="BMW"] .filter-item__title, 
  .shop-by-make .filter-item[data-make="BMW"] .filter-item__img {
    background-color: #1c69d3;
  }
  
  /* Make - Buick */

  .shop-by-make .filter-item[data-make="Buick"] .filter-item__title, 
  .shop-by-make .filter-item[data-make="Buick"] .filter-item__img {
    background-color: #2b2b2b;
  }
  
  /* Make - Cadillac */

  .shop-by-make .filter-item[data-make="Cadillac"] .filter-item__title, 
  .shop-by-make .filter-item[data-make="Cadillac"] .filter-item__img {
    background-color: #000000;
  }
  
  /* Make - Chevrolet */

  .shop-by-make .filter-item[data-make="Chevrolet"] .filter-item__title, 
  .shop-by-make .filter-item[data-make="Chevrolet"] .filter-item__img {
    background-color: #CD9834;
  }
  
  /* Make - Chrysler */

  .shop-by-make .filter-item[data-make="Chrysler"] .filter-item__title, 
  .shop-by-make .filter-item[data-make="Chrysler"] .filter-item__img {
    background-color: black;
  }
  
  /* Make - Dodge */

  .shop-by-make .filter-item[data-make="Dodge"] .filter-item__title, 
  .shop-by-make .filter-item[data-make="Dodge"] .filter-item__img {
    background-color: #FF0000;
  }
  
  /* Make - Ford */

  .shop-by-make .filter-item[data-make="Ford"] .filter-item__title, 
  .shop-by-make .filter-item[data-make="Ford"] .filter-item__img {
    background-color: #00095B;
  }
  
  /* Make - Genesis */

  .shop-by-make .filter-item[data-make="Genesis"] .filter-item__title, 
  .shop-by-make .filter-item[data-make="Genesis"] .filter-item__img {
    background-color: #000000;
  }
  
  /* Make - GMC */

  .shop-by-make .filter-item[data-make="GMC"] .filter-item__title, 
  .shop-by-make .filter-item[data-make="GMC"] .filter-item__img {
    background-color: #AA0000;
  }
  
  /* Make - Harley Davidson */

  .shop-by-make .filter-item[data-make="Harley Davidson"] .filter-item__title, 
  .shop-by-make .filter-item[data-make="Harley Davidson"] .filter-item__img {
    background-color: #FA6600;
  }
  
  /* Make - Honda */

  .shop-by-make .filter-item[data-make="Honda"] .filter-item__title, 
  .shop-by-make .filter-item[data-make="Honda"] .filter-item__img {
    background-color: #007cc0;
  }
  
  /* Make - Hyundai */

  .shop-by-make .filter-item[data-make="Hyundai"] .filter-item__title, 
  .shop-by-make .filter-item[data-make="Hyundai"] .filter-item__img {
    background-color: #002c5f;
  }
  
  /* Make - Infiniti */

  .shop-by-make .filter-item[data-make="Infiniti"] .filter-item__title, 
  .shop-by-make .filter-item[data-make="Infiniti"] .filter-item__img {
    background-color: #000000;
  }
  
  /* Make - Jaguar */

  .shop-by-make .filter-item[data-make="Jaguar"] .filter-item__title, 
  .shop-by-make .filter-item[data-make="Jaguar"] .filter-item__img {
    background-color: #3c3c3b;
  }
  
  /* Make - Jeep */

  .shop-by-make .filter-item[data-make="Jeep"] .filter-item__title, 
  .shop-by-make .filter-item[data-make="Jeep"] .filter-item__img {
    background-color: #000000;
  }
  
  /* Make - Kia */

  .shop-by-make .filter-item[data-make="Kia"] .filter-item__title, 
  .shop-by-make .filter-item[data-make="Kia"] .filter-item__img {
    background-color: #05141F;
  }
  
  /* Make - Land Rover */

  .shop-by-make .filter-item[data-make="Land Rover"] .filter-item__title, 
  .shop-by-make .filter-item[data-make="Land Rover"] .filter-item__img {
    background-color: #005A2B;
  }
  
  /* Make - Lexus */

  .shop-by-make .filter-item[data-make="Lexus"] .filter-item__title, 
  .shop-by-make .filter-item[data-make="Lexus"] .filter-item__img {
    background-color: #000000;
  }
  
  /* Make - Lincoln */

  .shop-by-make .filter-item[data-make="Lincoln"] .filter-item__title, 
  .shop-by-make .filter-item[data-make="Lincoln"] .filter-item__img {
    background-color: #5b6770;
  }
  
  /* Make - Maserati */

  .shop-by-make .filter-item[data-make="Maserati"] .filter-item__title, 
  .shop-by-make .filter-item[data-make="Maserati"] .filter-item__img {
    background-color: #0C2340;
  }
  
  /* Make - Mazda */

  .shop-by-make .filter-item[data-make="Mazda"] .filter-item__title, 
  .shop-by-make .filter-item[data-make="Mazda"] .filter-item__img {
    background-color: #101010;
  }
  
  /* Make - Mercedes-Benz */

  .shop-by-make .filter-item[data-make="Mercedes-Benz"] .filter-item__title, 
  .shop-by-make .filter-item[data-make="Mercedes-Benz"] .filter-item__img {
    background-color: #000000;
  }
  
  /* Make - MINI */

  .shop-by-make .filter-item[data-make="MINI"] .filter-item__title, 
  .shop-by-make .filter-item[data-make="MINI"] .filter-item__img {
    background-color: #00779c;
  }

  /* Make - Mitsubishi */

  .shop-by-make .filter-item[data-make="Mitsubishi"] .filter-item__title, 
  .shop-by-make .filter-item[data-make="Mitsubishi"] .filter-item__img {
    background-color: #ed0000;
  }
  
  /* Make - Nissan */

  .shop-by-make .filter-item[data-make="Nissan"] .filter-item__title, 
  .shop-by-make .filter-item[data-make="Nissan"] .filter-item__img {
    background-color: #C3002F;
  }
  
  /* Make - Porsche */

  .shop-by-make .filter-item[data-make="Porsche"] .filter-item__title, 
  .shop-by-make .filter-item[data-make="Porsche"] .filter-item__img {
    background-color: #000000;
  }
  
  /* Make - Ram */

  .shop-by-make .filter-item[data-make="Ram"] .filter-item__title, 
  .shop-by-make .filter-item[data-make="Ram"] .filter-item__img {
    background-color: #000000;
  }
  
  /* Make - Subaru */

  .shop-by-make .filter-item[data-make="Subaru"] .filter-item__title, 
  .shop-by-make .filter-item[data-make="Subaru"] .filter-item__img {
    background-color: #1971d4;
  }
  
  /* Make - Toyota */

  .shop-by-make .filter-item[data-make="Toyota"] .filter-item__title, 
  .shop-by-make .filter-item[data-make="Toyota"] .filter-item__img {
    background-color: #EB0A1E;
  }
  
  /* Make - Volkswagen */

  .shop-by-make .filter-item[data-make="Volkswagen"] .filter-item__title, 
  .shop-by-make .filter-item[data-make="Volkswagen"] .filter-item__img {
    background-color: #001e50;
  }
  
  /* Make - Volvo */

  .shop-by-make .filter-item[data-make="Volvo"] .filter-item__title, 
  .shop-by-make .filter-item[data-make="Volvo"] .filter-item__img {
    background-color: #182871;
  }

  /* Mobile Tabbed Filter */

  .homepage-tabbed-filter--mobile .tabbed-filter-content > .container-fluid {
    padding: 0;
  }

  .homepage-tabbed-filter:not(.homepage-tabbed-filter--mobile) .tabbed-filter-trigger {
    opacity: 0;
    pointer-events: none;
    visibility: hidden;
    position: absolute;
    z-index: -2147483647;
  }

  .tabbed-filter-btn[data-trigger="open"] {
    display: inline-flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    width: 100%;
    max-width: 350px;
    background-color: var(--primary-dark);
    color: #ffffff;
    border: solid 2px var(--primary-dark);
    border-radius: 50px;
    padding: 10px 30px 12px 30px;
    margin: 7px 0;
    font-size: 22px;
    -webkit-transition: all 0.3s ease;
    -moz-transition: all 0.3s ease;
    transition: all 0.3s ease;
  }
  
  .tabbed-filter-btn[data-trigger="open"]:hover, 
  .tabbed-filter-btn[data-trigger="open"]:active, 
  .tabbed-filter-btn[data-trigger="open"]:focus {
    outline: none;
    background-color: var(--primary-dark);
    border-color: var(--primary-dark);
    color: #ffffff;
  }

  .tabbed-filter-btn[data-trigger="open"] .filter-icon {
    display: inline-block;
    width: 20px;
    height: 20px;
    margin: 5px 0 0 20px;
    background-image: url(https://d2v1gjawtegg5z.cloudfront.net/uploads/files/000/348/380/original/filter-slider-white_300x.png?1673643691);
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
  }

  .homepage-tabbed-filter:not(.homepage-tabbed-filter--mobile) .tabbed-filter-btn[data-trigger="close"] {
    display: none;
  }

  .tabbed-filter-content .tabbed-filter-btn.close {
    position: absolute;
    top: 1%;
    right: 3%;
    font-size: 35px;
    font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
    font-weight: 400;
  }

  .homepage-tabbed-filter--mobile .tabbed-filter-content {
    overflow-x: hidden;
    overflow-y: scroll;
    position: fixed;
    z-index: 2147483647;
    left: 0;
    bottom: -100vh;
    width: 100%;
    height: 625px;
    max-height: 80vh;
    border-radius: 15px 15px 0 0;
    -webkit-box-shadow: -3px -3px 6px #00000033;
    -moz-box-shadow: -3px -3px 6px #00000033;
    box-shadow: -3px -3px 6px #00000033;
    padding-top: 30px;
    padding-bottom: 80px;
    -webkit-transition: all 0.3s cubic-bezier(0.68, 0, 0.27, 1);
    -moz-transition: all 0.3s cubic-bezier(0.68, 0, 0.27, 1);
    transition: all 0.3s cubic-bezier(0.68, 0, 0.27, 1);
  }

  .homepage-tabbed-filter--mobile.open .tabbed-filter-content {
    bottom: 0;
  }

  .homepage-tabbed-filter--mobile .filter-ui > .nav-tabs {
    display: none;
  }

  .homepage-tabbed-filter--mobile .filter-ui > .tab-content {
    display: block;
    height: fit-content;
    padding: 0;
  }

  .homepage-tabbed-filter--mobile .tab-pane {
    border: 0;
    border-radius: 0;
  }

  .homepage-tabbed-filter--mobile .filter-ui > .tab-content > .tab-pane:not(#tabShopByPayment, #tabShopByResults) .tab-pane-content {
    width: calc(100% + 15px);
  }

  .homepage-tabbed-filter--mobile .component-tab-pane {
    display: block !important;
    opacity: 1;
    overflow: hidden;
    height: fit-content;
    padding-top: 20px;
    padding-bottom: 0;
  }

  .homepage-tabbed-filter--mobile .component-tab-pane::after {
    content: '';
    display: block;
    width: 100%;
    height: 2px;
    background-color: #f6f6f6;
    margin-top: 20px;
  }
  .homepage-tabbed-filter--mobile .component-tab-pane, 
  .homepage-tabbed-filter--mobile .results-tab-pane {
    padding-left: 15px;
    padding-right: 15px;
  }
  
  .homepage-tabbed-filter--mobile .tab-pane.active {
    display: block;
  }

  .homepage-tabbed-filter .tab-pane-content {
    width: 100%;
  }
  
  .homepage-tabbed-filter:not(.homepage-tabbed-filter--mobile) .tab-pane-content, 
  .homepage-tabbed-filter--mobile .tab-pane-content.collapse.in {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    column-gap: 10px;
  }

  .homepage-tabbed-filter--mobile #collapsePaymentFilter.tab-pane-content.collapse.in {
    flex-direction: column;
    align-items: flex-start;
  }

  .homepage-tabbed-filter:not(.homepage-tabbed-filter--mobile) .mobile-tab-pane-title {
    display: none;
  }
  
  .homepage-tabbed-filter--mobile #tabShopByPayment.component-tab-pane {
    display: block;
  }

  .homepage-tabbed-filter--mobile #tabShopByPayment .nav-tabs, 
  .homepage-tabbed-filter--mobile #tabShopByPayment .component {
    display: block;
    width: 100%;
    max-width: 100%;
  }

  .homepage-tabbed-filter:not(.homepage-tabbed-filter--mobile) #tabShopByPayment .nav-tabs {
    margin-right: 20px;
  }

  .homepage-tabbed-filter--mobile #tabShopByPayment .nav-tabs {
    margin-bottom: 20px;
  }

  .homepage-tabbed-filter--mobile #tabShopByPayment .nav-tabs>li>a {
    margin: 0 20px 0 0;
  }

  .homepage-tabbed-filter--mobile .shop-by-model, 
  .homepage-tabbed-filter--mobile .shop-by-make {
    padding-left: 0;
  }

  .homepage-tabbed-filter--mobile .btn-branded {
    background-color: var(--primary-dark);
    border-color: var(--primary-dark);
    width: 100%;
    padding: 15px 20px;
    font-size: 16px;
  }

  .homepage-tabbed-filter--mobile .btn-branded:hover, 
  .homepage-tabbed-filter--mobile .btn-branded:active, 
  .homepage-tabbed-filter--mobile .btn-branded:focus {
    color: #ffffff;
    opacity: 0.7;
  }
  
  .homepage-tabbed-filter--mobile .tab-pane-content {
    margin-top: 20px;
  }

  .homepage-tabbed-filter .collapse-tab-pane-content {
    font-size: 16px;
    color: var(--primary-dark);
    text-shadow: 0 0 var(--primary-dark);
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }

  .collapse-tab-pane-content:hover, 
  .collapse-tab-pane-content:active, 
  .collapse-tab-pane-content:focus {
    color: var(--primary-dark);
    text-decoration: none;
  }

  .homepage-tabbed-filter .collapse-tab-pane-content.collapsed {
    color: #c6c6c6;
    text-shadow: 0 0 #c6c6c6;
  }

  .homepage-tabbed-filter--mobile #tabShopByPayment .nav-tabs>li>a {
    font-size: 13px;
    margin-bottom: 7px;
  }

  .homepage-tabbed-filter--mobile #shopByPayment .irs--round .irs-handle {
    width: 35px;
    height: 35px;
    top: 20px;
  }

  .homepage-tabbed-filter--mobile #shopByPayment .irs--round  .irs-single {
    top: -7px;
  }

  .homepage-tabbed-filter--mobile .filter-item {
    flex-direction: column;
    align-items: flex-start;
    width: 125px;
    height: 175px;
  }

  .homepage-tabbed-filter--mobile .filter-item__img, 
  .homepage-tabbed-filter--mobile .filter-item__title {
    width: 100%;
  }

  .homepage-tabbed-filter--mobile .filter-item__img {
    height: 60%;
    border-radius: 6px 6px 0 0;
  }

  .homepage-tabbed-filter--mobile .filter-item__title {
    height: 40%;
    border-radius: 0 0 6px 6px;
  }

  .homepage-tabbed-filter--mobile .scroll-overlay, 
  .homepage-tabbed-filter--mobile .scroll-nav {
    display: none !important;
  }

  .homepage-tabbed-filter--mobile .filter-item__title .dynamic-results {
    top: 2%;
  }

  .homepage-tabbed-filter--mobile .filter-item__title .fa-check-circle {
    top: 35%;
    right: unset;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .homepage-tabbed-filter .collapse-indicator {
    display: inline-block;
    position: relative;
    background-color: #c6c6c6;
    width: 45px;
    height: 27px;
    border-radius: 50px;
  }

  .homepage-tabbed-filter .component-tab-pane.active .collapse-indicator {
    background-color: var(--primary-dark);
  }

  .homepage-tabbed-filter .collapse-indicator, 
  .homepage-tabbed-filter .collapse-indicator .indicator-circle {
    -webkit-transition: all 0.2s ease;
    -moz-transition: all 0.2s ease;
    transition: all 0.2s ease;
  }

  .homepage-tabbed-filter .collapse-indicator .indicator-piece {
    position: absolute;
  }

  .homepage-tabbed-filter .collapse-indicator .indicator-line {
    width: 60%;
    height: 1px;
    background-color: #ffffff;
    left: 50%;
    transform: translate(-50%);
  }

  .homepage-tabbed-filter .collapse-indicator .indicator-line--top {
    top: 33%;
  }

  .homepage-tabbed-filter .collapse-indicator .indicator-line--bottom {
    top: 66%;
  }

  .homepage-tabbed-filter .collapse-indicator .indicator-circle {
    width: 17%;
    height: 28%;
    border-radius: 50%;
    background: radial-gradient(#c6c6c6 40%, #ffffff 40%);
  }

  .homepage-tabbed-filter .collapse-indicator .indicator-circle--top {
    top: 22%;
    left: 53%;
  }

  .homepage-tabbed-filter .collapse-indicator .indicator-circle--bottom {
    top: 55%;
    left: 29%;
  }

  .homepage-tabbed-filter .component-tab-pane.active .collapse-indicator .indicator-circle {
    background: radial-gradient(var(--primary-dark) 40%, #ffffff 40%);
  }

  .homepage-tabbed-filter .component-tab-pane.active .collapse-indicator .indicator-circle--top {
    left: 29%;
  }

  .homepage-tabbed-filter .component-tab-pane.active .collapse-indicator .indicator-circle--bottom {
    left: 53%;
  }

  /* .homepage-tabbed-filter--mobile.open .filter-ui > .tab-content.display-results .component-tab-pane.active[data-is-active="true"] ~ #tabShopByResults {
    display: block;
    position: fixed;
    top: 85%;
  } */
  
  .homepage-tabbed-filter--mobile.open .filter-ui > .tab-content .component-tab-pane ~ #tabShopByResults {
    display: block !important;
    position: fixed;
    height: fit-content;
    bottom: 5%;
  }

  .homepage-tabbed-filter--mobile .component-tab-pane .scroll-horizontal {
    margin-left: -15px;
    width: calc(100% + 15px);
  }

  /* Faceted Search - Additions */

  .tabbed-filter-content #tabShopAllInventory, 
  .tabbed-filter-content .filter-ui > .tab-content.display-results #tabShopByResults {
    -webkit-transition: all 0.3s ease;
    -moz-transition: all 0.3s ease;
    transition: all 0.3s ease;
  }

  #tabbedSearchFilterComponent[data-has-color-fill="true"] .tabbed-filter-content #tabShopAllInventory {
    background-color: var(--primary-color);
    border-color: var(--primary-color);
  }

  #tabbedSearchFilterComponent[data-has-color-fill="true"][data-brand-uses-dark-color-for-primary="true"] .tabbed-filter-content #tabShopAllInventory {
    background-color: var(--primary-dark);
    border-color: var(--primary-dark);
  }

  #tabbedSearchFilterComponent[data-has-color-fill="true"] .tabbed-filter-content #tabShopAllInventory i.material-icons {
    color: rgb(255 255 255 / 80%);
  }

  #tabbedSearchFilter #shopByFacetedSearch:not([data-select-appearance="menulist"]) .search-dropdown {
    padding-right: 15px;
  }

  #tabShopAllInventory .search-dropdown {
    border-radius: 6px;
    border: solid 1px #E5E5E5;
    position: relative;
  }

  .tabbed-filter-content #tabShopAllInventory .search-dropdown {
    margin: 0 5px;
  }
  .tabbed-filter-content #tabShopAllInventory .first-search-dropdown {
    margin-left: 15px;
  }

  #tabShopAllInventory i.material-icons {
    pointer-events: none;
    font-size: 20px;
    position: absolute;
    right: 12px;
    top: 50%;
    transform: translateY(-50%);
  }

  #tabShopAllInventory select.vehicle-search {
    box-shadow: none;
    border: 0;
    color: var(--primary-dark);
    background-color: transparent;
    -moz-appearance: none;
    -webkit-appearance: none;
    appearance: none;
  }
  .tabbed-filter-content #tabShopAllInventory select.vehicle-search {
    height: 48px;
  }

  .homepage-tabbed-filter--mobile #tabShopAllInventory select.vehicle-search {
    height: 37px;
    background-color: #ffffff;
  }

  .tabbed-filter-content #tabShopAllInventory select.vehicle-search {
    width: 200px;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  #tabbedSearchFilterComponent[data-has-color-fill="true"] .tabbed-filter-content #tabShopAllInventory .search-dropdown {
    border: solid 1px rgb(255 255 255 / 20%);
  }

  #tabbedSearchFilterComponent[data-has-color-fill="true"] .tabbed-filter-content #tabShopAllInventory select.vehicle-search {
    color: #ffffff;
    background-color: transparent;
    border: 0;
  }

  #tabbedSearchFilterComponent[data-has-color-fill="true"] .tabbed-filter-content .filter-ui > .tab-content.display-results #tabShopByResults {
    background-color: var(--primary-color);
    border-color: var(--primary-color);
    opacity: 0.9;
  }

  #tabbedSearchFilterComponent[data-has-color-fill="true"][data-brand-uses-dark-color-for-primary="true"] .tabbed-filter-content .filter-ui > .tab-content.display-results #tabShopByResults {
    background-color: var(--primary-dark);
    border-color: var(--primary-dark);
  }

  .homepage-tabbed-filter--mobile #tabShopAllInventory .component {
    width: calc(100% - 15px);
    margin-right: 15px;
  }

  .homepage-tabbed-filter--mobile #tabShopAllInventory .search-dropdown {
    margin-bottom: 7px;
    padding: 5px;
  }

  /* No Results */

  .homepage-tabbed-filter .component-tab-pane.active ~ #tabShopByResults .shop-by-results-btn[data-results-count="0"] {
    pointer-events: none;
    cursor: not-allowed;
    opacity: 0.65;
    -webkit-box-shadow: none;
    box-shadow: none;
    position: relative;
  }

  .homepage-tabbed-filter .component-tab-pane.active ~ #tabShopByResults .shop-by-results-btn[data-results-count="0"]::after {
    content: 'Try different search criteria';
    font-size: 11px;
    display: block;
    position: absolute;
    top: 107%;
    left: 50%;
    transform: translate(-50%, 0);
  }

  .homepage-tabbed-filter #tabShopByPayment.component-tab-pane.active ~ #tabShopByResults .shop-by-results-btn[data-results-count="0"]::after {
    content: 'Try different search criteria';
  }

  .homepage-tabbed-filter #tabShopByModel.component-tab-pane.active ~ #tabShopByResults .shop-by-results-btn[data-results-count="0"]::after {
    content: 'Select one or more models';
  }
  
  .homepage-tabbed-filter #tabShopByMake.component-tab-pane.active ~ #tabShopByResults .shop-by-results-btn[data-results-count="0"]::after {
    content: 'Select one or more makes';
  }

  .homepage-tabbed-filter #tabShopByResults .shop-by-results-btn[data-results-count="0"]::after {
    color: #ffffff;
  }
  .homepage-tabbed-filter--mobile #tabShopByResults .shop-by-results-btn[data-results-count="0"]::after {
    color: #333333;
  }

  /* SEARCH BAR ADD ONS */
  #homepageTabbedFilter .interaction-bar-search-bar {
    min-width: 450px;
    width: 30vw;
    padding: 0 15px;
  }
  #homepageTabbedFilter .interaction-bar-search-bar .search-bar .input-search, 
  #homepageTabbedFilter .interaction-bar-search-bar .search-bar button {
    height: 60px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }
  #homepageTabbedFilter .interaction-bar-search-bar .input-search {
    font-size: 20px;
    border: solid 2px #efefef;
    border-right: 0;
    -moz-box-shadow: none;
    -webkit-box-shadow: none;
    /* box-shadow: none; */
    padding: 6px 8px 6px 25px;
    padding-left: 4rem;
    border-radius: 6px 0 0 6px;
    background-color: #FAFAFA;
  }
  #homepageTabbedFilter .interaction-bar-search-bar .input-search:focus {
    outline: none;
  }
  #homepageTabbedFilter .interaction-bar-search-bar .input-search::placeholder {
    color: #333333;
    color: var(--pcd);
  }
  #homepageTabbedFilter .interaction-bar-search-bar .search-submit-btn {
    background-color: #FAFAFA;
  }
  #homepageTabbedFilter .interaction-bar-search-bar .search-submit-btn svg {
    margin-top: 4px;
  }
  #homepageTabbedFilter .interaction-bar-search-bar .search-submit-btn svg circle {
    fill: var(--primary-color);
  }
  /* #homepageTabbedFilter .interaction-bar-search-bar .search-submit-btn {
    padding: 10px 40px;
    margin-left: -5px;
    border: solid 2px;
    border-color: #333333;
    border-color: var(--search-btn-border-color, #000000);
    background-color: #ffffff;
    background-color: var(--search-btn-bg-color, #000000);
    color: #333333;
    color: var(--search-btn-color, #ffffff);
    -moz-transition: all 0.3s ease;
    -webkit-transition: all 0.3s ease;
    transition: all 0.3s ease;
  }
  #homepageTabbedFilter .interaction-bar-search-bar .search-submit-btn:hover, 
  #homepageTabbedFilter .interaction-bar-search-bar .search-submit-btn:active, 
  #homepageTabbedFilter .interaction-bar-search-bar .search-submit-btn:focus {
    background-color: #333333;
    background-color: var(--search-btn-color, #ffffff);
    border-color: #333333;
    border-color: var(--search-btn-border-color, #000000);
    color: #ffffff;
    color: var(--search-btn-bg-color, #000000);
  } */
  .full-width-search-bar.search-bar-component {
    margin: 12px 35px 20px 35px;
    border-radius: 6px;
    max-width: calc(1512px - 70px);
    background-color: transparent;
  }

  #homepageTabbedFilter {
    padding-top: 12px;
    max-width: 1512px;
    margin-left: auto;
    margin-right: auto;
    /* --pc: var(--primary-color, #000000);
    --pcd: var(--primary-dark, #000000);
    --scroll-overlay-gradient-rgba-min: rgba(239, 239, 239, 0);
    --scroll-overlay-gradient-rgba-max: rgba(239, 239, 239, 1);
    --search-btn-bg-color: var(--pcd);
    --search-btn-border-color: var(--pcd);
    --search-btn-color: #ffffff; */
  }
  .full-width-search-bar.search-bar-component>.container {
    width: 100%;
    padding-left: 5px;
    margin: 0;
  }
  .full-width-search-bar.search-bar-component>.container>.row>div[class*="col-"] {
    width: 100%;
    margin-left: 0;
    padding-left: 5px;
  }
  .full-width-search-bar.search-bar-component .search-bar {
    height: 60px;
  }
  .full-width-search-bar.search-bar-component .search-bar>form[action="/vehicles"] {
    position: absolute;
    right: 0;
    width: 100%;
  }
  .input-search,
  .search-submit-btn {
    border-width: 2px;
    margin-top: 10px;
    border-color: #e5e5e5;
  }
  .full-width-search-bar.search-bar-component .input-group .form-control.input-search:first-child {
    border-top-left-radius: 6px;
    border-bottom-left-radius: 6px;
    border-right: 0;
    box-shadow: none;
  }
  .full-width-search-bar.search-bar-component .input-group-btn:last-child>.btn:not(:last-child):not(.dropdown-toggle) {
    border-top-right-radius: 6px;
    border-bottom-right-radius: 6px;
    border-left: 0
  }
  .filter-ui>.nav-tabs>li>a {
    background-color: transparent
  }
  .filter-ui>.nav-tabs>li>a[href="#tabShopByMake"] {
    display: none;
  }
  .tab-pane {
    border-radius: 6px
  }
  #homepageTabbedFilter .tab-content {
    padding-top: 12px;
  }
  #homepageTabbedFilter .filter-ui>.nav-tabs>li>a {
    background-color: transparent;
    font-weight: 700;
  }
  #homepageTabbedFilter .filter-ui>.nav-tabs>li.active>a:hover,
  #homepageTabbedFilter .filter-ui>.nav-tabs>li>a:hover {
    color: var(--primary-dark);
  }
  .fa-search {
    font-size: 1.25rem;
  }

  .tabbed-search-filter:not(.search-filter--mobile) {
    max-width: 40%;
  }
  .tabbed-search-filter:not(.search-filter--mobile) .tab-pane-content {
    justify-content: flex-start;
  }

  /* .tabbed-search-filter:not(.search-filter--mobile) .filter-ui > .tab-content.display-results > .tab-pane.active[data-is-active="true"] {
    border-top-right-radius: 0 !important;
    border-bottom-right-radius: 0 !important;
  } */

  @media (min-width: 768px) {
    .full-width-search-bar.search-bar-component .input-group .form-control.input-search:first-child {
      border-radius: 30px 0 0 30px;
    }

    /* .full-width-search-bar.search-bar-component .input-group-btn >.btn {
      border-radius: 0 30px 30px 0;
    } */
  }

  @media (min-width: 960px) {
    .filter-ui>.nav-tabs>li:nth-child(4) {
      left: calc(3% + 330px);
    }
    
    .full-width-search-bar.search-bar-component {
      border-radius: 10px;
    }

    .tab-pane {
      border-radius: 10px;
    }
  }

  /* #homepageTabbedFilter::before {
    content: "Quick Search";
    font-size: 3rem;
    display: block;
    text-align: center;
    font-weight: 600;
    margin: 2rem 0;
  } */

  @media (min-width: 768px) and (max-width: 991px) {
    #homepageTabbedFilter .full-width-search-bar.search-bar-component {
      margin-top:20px;
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0
  }

  #homepageTabbedFilter {
      padding-top: 0
  }

  #homepageTabbedFilter .filter-ui>.nav-tabs {
      margin: 0 20px;
      padding-bottom: 10px;
      border-bottom-left-radius: 6px;
      border-bottom-right-radius: 6px
  }

  #homepageTabbedFilter .tab-content {
      margin-top: 10px
  }
}

@media (min-width: 960px) {
  #homepageTabbedFilter .filter-ui>.nav-tabs>li {
      position:absolute;
      top: -50px;
      left: 3%
  }

  #homepageTabbedFilter .filter-ui>.nav-tabs>li:nth-child(2) {
      left: calc(3% + 165px)
  }

  #homepageTabbedFilter .filter-ui>.nav-tabs>li:nth-child(3) {
      left: calc(3% + 330px)
  }

  #homepageTabbedFilter .filter-ui>.nav-tabs>li:nth-child(4) {
      left: calc(3% + 475px)
  }

  #homepageTabbedFilter .filter-ui>.nav-tabs {
      position: relative;
  }

  #homepageTabbedFilter .filter-ui>.tab-content {
      margin-top: 5px;
      margin-bottom: 20px;
  }

  #homepageTabbedFilter .filter-ui>.nav-tabs>li>a {
      margin-left: 0;
  }

  .full-width-search-bar.search-bar-component .search-bar>form[action="/vehicles"] {
    width: 100%;
    position: absolute;
    right: 0;
  }
}

@media (min-width: 1512px) {
  .full-width-search-bar.search-bar-component {
      margin-left: auto;
      margin-right: auto;
  }
}

@media (max-width: 959px) {
  #homepageTabbedFilter {
    display: flex;
    flex-flow: column nowrap;
  }
  .tabbed-filter-trigger {
    order: 2;
    margin: 12px 0;
  }
  #homepageTabbedFilter .tabbed-filter-btn[data-trigger="open"] {
      width:100%;
      max-width: 100%;
      margin: 0 35px;
      border-radius: 6px
  }
}

@media (max-width: 575px) {
  .full-width-search-bar.search-bar-component {
      margin:12px 15px 0 15px;
      padding: 0
  }

  #homepageTabbedFilter .tabbed-filter-btn[data-trigger="open"] {
      margin: 0 15px
  }
}

.full-width-search-bar.search-bar-component {
    background-color: transparent
}

.full-width-search-bar.search-bar-component .input-group .form-control.input-search:first-child,.full-width-search-bar.search-bar-component .input-group-btn>.btn {
    background-color: #ffffff;
    border-color: #efefef
}
.full-width-search-bar.search-bar-component .input-group-btn>.btn {
  border-left: none;
  border-width: 2px;
}

/* @media (min-width: 768px) and (max-width: 991px) {
  #homepageTabbedFilter .filter-ui>.nav-tabs {
      background-color:#f7f7f7
  }
} */

#tabbed-search-filter-v-search-bar[data-theme="kia"] .full-width-search-bar.search-bar-component {
    background-color: #cccccc
}

#tabbed-search-filter-v-search-bar[data-theme="kia"] .full-width-search-bar.search-bar-component .input-group .form-control.input-search:first-child,#tabbed-search-filter-v-search-bar[data-theme="kia"] .full-width-search-bar.search-bar-component .input-group-btn:last-child>.btn:not(:last-child):not(.dropdown-toggle) {
    background-color: #f3f3f3;
    border-color: #cccccc
}

#tabbed-search-filter-v-search-bar[data-theme="kia"] .input-search,#tabbed-search-filter-v-search-bar[data-theme="kia"] .search-submit-btn {
    border-width: 1px
}

/* @media (min-width: 768px) and (max-width: 991px) {
  #tabbed-search-filter-v-search-bar[data-theme="kia"] #tabbedSearchFilterComponent .filter-ui>.nav-tabs {
      background-color:#cccccc
  }
} */

/*  END NEW ADD-ONS */

  /* Media Queries */

  @media (min-width: 768px) and (max-width: 1199px) {
    .homepage-tabbed-filter .filter-item {
      width: 220px;
    }

    #tabShopByPayment .nav-tabs>li>a {
      margin: 0 20px 0 0;
      font-size: 14px;
    }

    #tabShopByPayment .component.shop-by-payment {
      max-width: 50%;
    }

    .homepage-tabbed-filter:not(.homepage-tabbed-filter--mobile) #tabShopByPayment .nav-tabs {
      margin-right: 0;
    }
  }

  @media (max-width: 767px) {
    .homepage-tabbed-filter--mobile .tabbed-filter-content {
      height: 100%;
    }
    .homepage-tabbed-filter .scroll-parent {
      width: 100%;
    }

    .homepage-tabbed-filter .scroll-nav--left {
      left: 1%;
    }

    .homepage-tabbed-filter .scroll-nav--right {
      right: 1%;
    }
    #homepageTabbedFilter .interaction-bar-search-bar {
      min-width: unset;
      width: 100%;
      padding-top: 15px;
      padding-bottom: 5px;
    }
  }

  /* Prevent Scrolling on Mobile */

  html.modal-open, 
  body.modal-open {
    height: 100%;
  }

  /* Toyota */

  .homepage-tabbed-filter[data-brand="Toyota"] .btn-branded {
    border-radius: 50px;
    padding: 10px 20px 12px 20px;
  }

  /* CJDR STYLES */
  #homepageTabbedFilter[data-brand="Cjdr"] :deep(.irs--round .irs-handle) {
    background: radial-gradient(circle, #fff 50%, var(--primary-color, #000) 51%);
    top: 28px;
    width: 20px;
    height: 20px;
  }

  #homepageTabbedFilter[data-brand="Cjdr"] :deep(.irs--round .irs-bar),
  #homepageTabbedFilter[data-brand="Cjdr"] :deep(.irs--round .irs-line) {
    height: 4px;
  }

  #homepageTabbedFilter[data-brand="Cjdr"] :deep(.irs--round .irs-single) {
    font-weight: 600;
  }
  #homepageTabbedFilter[data-brand="Cjdr"] .tab-content .results-placeholder-link {
    background-color: var(--primary-dark);
    font-family: "Barlow Condensed", sans-serif;
    font-weight: 700;
    font-style: normal;
    font-size: 1.25rem;
    text-transform: uppercase;
  }
  #homepageTabbedFilter[data-brand="Cjdr"] {
    padding-bottom: 12px;
  }
  #homepageTabbedFilter[data-brand="Cjdr"] a {
    font-weight: bold;
  }
  #homepageTabbedFilter[data-brand="Cjdr"] .full-width-search-bar.search-bar-component .container {
    display: none;
  }
  #homepageTabbedFilter[data-brand="Cjdr"] .tab-content .results-placeholder-link svg circle,
  #homepageTabbedFilter[data-brand="Cjdr"] .tab-content .shop-by-results-btn svg circle {
    fill: var(--primary-color);
  }
  #homepageTabbedFilter[data-brand="Cjdr"] .tab-content .results-placeholder-link svg path,
  #homepageTabbedFilter[data-brand="Cjdr"] .tab-content .shop-by-results-btn svg path {
    stroke: var(--primary-light);
  }
  #homepageTabbedFilter[data-brand="Cjdr"] .tabbed-filter-btn[data-trigger="open"] {
    font-family: "Barlow Condensed", sans-serif;
    font-weight: 700;
    font-style: normal;
    text-transform: uppercase;
  }
  .homepage-tabbed-filter--mobile[data-brand="Cjdr"] #tabShopByPayment .nav-tabs {
    border: none;
  }
  #homepageTabbedFilter[data-brand="Cjdr"] #tabShopByMake {
    display: none !important;
  }
  #homepageTabbedFilter[data-brand="Cjdr"] .shop-by-results-btn {
    border: none;
    display: inline-flex;
    align-items: center;
    font-size: 1.25rem;
    font-weight: 700;
    font-style: normal;
    font-family: "Barlow Condensed", sans-serif;
    text-transform: uppercase;
  }
  #homepageTabbedFilter[data-brand="Cjdr"] .shop-by-results-btn:hover,
  #homepageTabbedFilter[data-brand="Cjdr"] .shop-by-results-btn:focus,
  #homepageTabbedFilter[data-brand="Cjdr"] .shop-by-results-btn:active {
    background-color: transparent;
    border-radius: 0;
    outline: none;
    color: var(--primary-light);
    opacity: 0.7;
  }
  #homepageTabbedFilter[data-brand="Cjdr"] .results-btn-txt {
    padding: 0 8px 0 2.5px;
  }
  #homepageTabbedFilter .tab-content.display-results .results-placeholder-link,
  #homepageTabbedFilter .filter-ui > .tab-content.display-results .component-tab-pane.active[data-is-active="true"] ~ .results-placeholder-link {
    display: none;
  }
  #homepageTabbedFilter .filter-ui > .tab-content.display-results .component-tab-pane[data-is-active="true"] ~ #tabShopByResults {
    display: inline-flex;
  }
  #homepageTabbedFilter .filter-ui > .tab-content.display-results .component-tab-pane.active[data-is-active="false"] ~ #tabShopByResults {
    display: none;
  }
  #homepageTabbedFilter .filter-ui > .tab-content.display-results #tabShopAllInventory[data-is-active="true"] ~ #tabShopByModel.active[data-is-active="false"] ~ #tabShopByResults,
  #homepageTabbedFilter .filter-ui > .tab-content.display-results #tabShopAllInventory[data-is-active="true"] ~ #tabShopByModel.active:not([data-is-active="false"]) ~ #tabShopByResults,
  #homepageTabbedFilter .filter-ui > .tab-content.display-results #tabShopByPayment[data-is-active="true"] ~ #tabShopByModel.active[data-is-active="false"] ~ #tabShopByResults,
  #homepageTabbedFilter .filter-ui > .tab-content.display-results #tabShopByPayment[data-is-active="true"] ~ #tabShopByModel.active:not([data-is-active="false"]) ~ #tabShopByResults {
    display: none;
  }
  #homepageTabbedFilter .filter-ui > .tab-content.display-results #tabShopAllInventory[data-is-active="true"] ~ #tabShopByModel.active[data-is-active="true"] ~ #tabShopByResults,
  #homepageTabbedFilter .filter-ui > .tab-content.display-results #tabShopByPayment[data-is-active="true"] ~ #tabShopByModel.active[data-is-active="true"] ~ #tabShopByResults {
    display: inline-flex;
  }
  #homepageTabbedFilter[data-brand="Cjdr"] .shop-by-model label[data-model*="Chrysler"] .filter-item__title {
    background-color: #17B4F1 !important;
  }
  #homepageTabbedFilter[data-brand="Cjdr"] .shop-by-model label[data-model*="Jeep"] .filter-item__title,
  #homepageTabbedFilter[data-brand="Cjdr"] .shop-by-model label[data-model*="Wagoneer"] .filter-item__title {
    background-color: #4c4c4cff !important;
  }
  #homepageTabbedFilter[data-brand="Cjdr"] .shop-by-model label[data-model*="RAM"] .filter-item__title {
    background-color: #F2CB05 !important;
    color: #000;
  }
  #homepageTabbedFilter[data-brand="Cjdr"] .filter-item {
    width: 260px;
  }
  #homepageTabbedFilter[data-brand="Cjdr"] .filter-item__img {
    background-position: center;
  }
  
  /* Kia */
  
  .homepage-tabbed-filter[data-brand="Kia"] .btn-branded {
    border-radius: 0;
  }
  .homepage-tabbed-filter[data-brand="Kia"] .tabbed-filter-content #tabShopAllInventory {
    background-color: var(--primary-color);
    border-color: var(--primary-color);
  }
  .homepage-tabbed-filter[data-brand="Kia"] .tabbed-filter-content #tabShopAllInventory {
    background-color: var(--primary-dark);
    border-color: var(--primary-dark);
  }
  .homepage-tabbed-filter[data-brand="Kia"] .tabbed-filter-content #tabShopAllInventory i.material-icons {
    color: rgb(255 255 255 / 80%);
  }
  .homepage-tabbed-filter[data-brand="Kia"] .tabbed-filter-content #tabShopAllInventory .search-dropdown {
    border: solid 1px rgb(255 255 255 / 20%);
  }
  .homepage-tabbed-filter[data-brand="Kia"] .tabbed-filter-content #tabShopAllInventory select.vehicle-search {
    color: #ffffff;
    background-color: transparent;
    border: 0;
  }
  .homepage-tabbed-filter[data-brand="Kia"] .tabbed-filter-content .filter-ui > .tab-content.display-results #tabShopByResults {
    background-color: var(--primary-color);
    border-color: var(--primary-color);
    opacity: 0.9;
  }
  .homepage-tabbed-filter[data-brand="Kia"] .tabbed-filter-content .filter-ui > .tab-content.display-results #tabShopByResults {
    background-color: var(--primary-dark);
    border-color: var(--primary-dark);
  }
  .homepage-tabbed-filter[data-brand="Kia"] .tabbed-filter-content .nav-tabs a {
    font-weight: bold;
  }

  /* MITSUBISHI */
  #homepageTabbedFilter[data-brand="Mitsubishi"] {
    font-family: futura-pt, "Avenir", Helvetica, Arial, sans-serif;
  }

  /* INFINITI */

  @media (min-width: 960px) {
    #homepageTabbedFilter[data-brand="Infiniti"] #tabShopAllInventory {
      background-color: var(--primary-color, #020B24);
      border-color: var(--primary-color, #020B24);
      color: var(--primary-light, #ffffff);
    }
    #homepageTabbedFilter[data-brand="Infiniti"] #tabShopAllInventory .search-dropdown {
      border-color: var(--secondary-dark, #E6E6E6);
    }
    #homepageTabbedFilter[data-brand="Infiniti"] #tabShopAllInventory .vehicle-search {
      color: var(--primary-light, #ffffff);
      background-color: transparent;
    }
  }
  #homepageTabbedFilter[data-brand="Infiniti"] .tab-pane.active .mobile-tab-pane-title a {
    color: var(--primary-color, #020B24);
  }
  #homepageTabbedFilter[data-brand="Infiniti"] .filter-item__img {
    background-color: #DFDBD3;
  }
  #homepageTabbedFilter[data-brand="Infiniti"] .collapse-tab-pane-content {
    color: var(--primary-light, #ffffff);
    text-shadow: 0 0 var(--primary-light, #ffffff);
  }
  #homepageTabbedFilter[data-brand="Infiniti"] .collapse-tab-pane-content.collapsed {
    color: var(--secondary-dark);
    text-shadow: 0 0 var(--secondary-dark, #646464);
  }
  #homepageTabbedFilter[data-brand="Infiniti"] #tabShopByMake {
    display: none !important;
  }

</style>

<style scoped>
  #homepageTabbedFilter[data-brand="Ford"] {
    --primary-color: var(--secondary-color) !important;
    background: url(https://d2v1gjawtegg5z.cloudfront.net/uploads/files/001/866/637/original/grid-pattern.png?1768410421) repeat, radial-gradient(circle, rgba(6, 111, 239, 0.18) 0%, rgba(6, 111, 239, 0.05) 45%, rgba(255, 255, 255, 0.9) 80%, rgba(255, 255, 255, 1) 100%);
    padding-bottom: 5rem;
  }
  .tabbed-search-title {
    font-size: 1.5rem;
    color: var(--pc, #000000);
  }
  .tabbed-search-heading {
    color: var(--pcd);
  }
  .full-width-search-bar.search-bar-component .input-group span.alternate-magnifying-glass-icon {
    position: absolute;
    left: 10px;
    top: 60%;
    transform: translateY(-50%);
    pointer-events: none;
    z-index: 4;
  }
  .full-width-search-bar.search-bar-component .input-group span.alternate-magnifying-glass-icon svg path {
    stroke: var(--primary-color);
  }
  #homepageTabbedFilter .filter-ui>.nav-tabs::before {
    content: "";
    position: absolute;
    border: 2px solid #E5E5E5;
    pointer-events: none;
    margin: -90px 20px 0;
    width: calc(100% - 40px);
    height: 80px;
    padding: 0;
    border-radius: 10px;
    background-color: #fff;
  }
  #homepageTabbedFilter .filter-ui>.nav-tabs::after {
    content: "";
    position: absolute;
    border: 2px solid #E5E5E5;
    pointer-events: none;
    margin: 150px 20px 0 10px;
    width: calc(100% - 80px);
    height: 100px;
    padding: 0;
    border-radius: 10px;
    z-index: 2;
  }
  #homepageTabbedFilter .tab-content .results-placeholder-link {
    height: 100%;
    background-color: var(--primary-color);
    color: #ffffff;
    border-radius: 10px;
    width: 200px;
    margin-right: 10px;
    font-size: 1rem;
    text-decoration: none;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    transition: all 0.3s ease-in-out;
  }
  #tabShopByModel.active ~ .results-placeholder-link,
  #tabShopByMake.active ~ .results-placeholder-link {
    display: none;
  }
  #homepageTabbedFilter .tab-content .results-placeholder-link * {
    display: block;
  }
  #homepageTabbedFilter .tab-content .results-placeholder-link .placeholder-count {
    margin-right: 5px;
  }
  #homepageTabbedFilter .tab-content .results-placeholder-link .placeholder-text {
    margin-right: 15px;
  }
  .homepage-tabbed-filter--mobile .results-placeholder-link {
    display: none;
  }
  .homepage-tabbed-filter--mobile #tabShopByPayment .nav-tabs {
    width: fit-content;
  }
  .homepage-tabbed-filter--mobile .collapse-tab-pane-content:focus {
    outline: none;
  }
  .homepage-tabbed-filter--mobile .btn-branded:hover, 
  .homepage-tabbed-filter--mobile .btn-branded:active, 
  .homepage-tabbed-filter--mobile .btn-branded:focus {
    background-color: var(--primary-dark);
  }
  @media (min-width: 992px) {
    #homepageTabbedFilter .filter-ui>.nav-tabs::before {
      inset: 0;
    }
    #homepageTabbedFilter .filter-ui>.nav-tabs::after {
      inset: 0;
      margin: 0 20px 0;
      width: calc(100% - 40px);
    }
    #homepageTabbedFilter .filter-ui>.nav-tabs>li {
      position: absolute;
      top: -66px;
      left: 3%;
    }
    .full-width-search-bar.search-bar-component .search-bar>form[action="/vehicles"] {
      width: calc(100% - 650px);
    }
  }

  @media (min-width: 768px) and (max-width: 991px) {
    #homepageTabbedFilter .filter-ui>.nav-tabs::before {
      margin: 30px 40px 10px 40px;
      width: calc(100% - 20px);
      height: 45px;
      z-index: 9;
    }
    #homepageTabbedFilter .filter-ui>.nav-tabs::after {
      inset: 0;
      margin: 40px 10px 0;
      width: calc(100% - 20px);
    }
    #homepageTabbedFilter .filter-ui>.nav-tabs>li {
      position: absolute;
      top: -5px;
      left: 3%;
      z-index: 9;
    }
    #homepageTabbedFilter .filter-ui>.tab-content {
      margin-top: 30px;
    }
    #homepageTabbedFilter .tab-content .results-placeholder-link {
      margin-right: 15px;
    }
  }
  @media (max-width: 1199px) {
    #homepageTabbedFilter:not(.homepage-tabbed-filter--mobile) #tabShopAllInventory .vehicle-search {
      max-width: calc(48vw / 4);
    }
    .homepage-tabbed-filter:not(.homepage-tabbed-filter--mobile) .tab-pane-content {
      margin-left: 5px;
    }
  }
</style>

<style>
  /* Tooltip */

  .homepage-tabbed-filter .tooltip {
    opacity: 1;
    min-width: 230px;
    position: absolute !important;
  }
  
  .homepage-tabbed-filter .tooltip.top {
    top: unset !important;
    bottom: 100% !important;
  }

  .homepage-tabbed-filter .tooltip-inner {
    background-color: #cecece;
    color: var(--primary-dark);
    padding: 7px 8px;
    font-size: 11px;
  }

  .homepage-tabbed-filter .tooltip.top .tooltip-arrow {
    border-top-color: #cecece;
  }
</style>